import React, { useState, useEffect, useRef } from 'react';
import {
    Wifi, Users, Building, Clock, Zap, Layers,
    PlusCircle, Trash2, Edit2, CheckCircle,
    XCircle, Loader2, Upload, Shield, MessageSquare,
    UserCheck, Search, Ban, Pencil, X, Save, Star, ArrowUpCircle, Menu,
    Hash, PauseCircle, StopCircle, AlertCircle, Landmark, Mail, Link2, Tag, ChevronDown, ChevronRight, Briefcase, ChevronLeft, Plus
} from 'lucide-react';
import { QRCodeCanvas } from 'qrcode.react';
import Papa from 'papaparse';
import api from '../services/api';
import { socket } from '../services/socket';
import Modal from '../components/Modal';
import ClientFormModal from '../components/ClientFormModal';

// --- CONFIGURAÇ?ÃO DE LIMITES POR PLANO ---
const PLAN_LIMITS = {
    'inicial': 1,
    'basic': 3,
    'pro': 10,
    'enterprise': 9999
};

// --- LISTA DE PERMISSÕ.ES DISPONÍVEIS ---
// --- LISTA DE PERMISSÕ.ES (AGRUPADAS) ---
const PERMISSIONS_GROUPS = [
    {
        title: "Administrativo",
        items: [
            { key: 'admin', label: 'Admin (Acesso Total - Ignora Bloqueios)' }
        ]
    },
    {
        title: "Bloqueios: Menu Principal",
        items: [
            { key: 'block_menu_dashboard', label: 'Bloquear Dashboard' },
            { key: 'block_menu_chat', label: 'Bloquear Conversas' },
            { key: 'block_menu_monitoring', label: 'Bloquear Monitoramento' },
            { key: 'block_menu_work_orders', label: 'Bloquear Ordens de Serviço' },
            { key: 'block_menu_internal_chat', label: 'Bloquear Chat Interno' },
            { key: 'block_menu_notices', label: 'Bloquear Mural de Avisos' },
            { key: 'block_menu_agenda', label: 'Bloquear Agenda' },
            { key: 'block_menu_scheduled_msgs', label: 'Bloquear Agendamentos' },
            { key: 'block_menu_notebook', label: 'Bloquear Caderno' },
            { key: 'block_config_subscription', label: 'Bloquear Assinatura' }
        ]
    },
    {
        title: "Bloqueios: Ações de Chat",
        items: [
            { key: 'block_chat_finish', label: 'Finalizar Atendimento' },
            { key: 'block_chat_cancel', label: 'Cancelar Atendimento' },
            { key: 'block_chat_pause', label: 'Pausar Atendimento' },
            { key: 'block_chat_transfer', label: 'Transferir (Interno)' },
            { key: 'block_chat_transfer_external', label: 'Transferir (Externo)' },
            { key: 'block_chat_add_attendant', label: 'Adicionar Atendente' },
            { key: 'block_chat_client_edit', label: 'Editar Cliente' },
            { key: 'block_chat_history', label: 'Ver Histórico' }
        ]
    },
    {
        title: "Bloqueios: Configurações",
        items: [
            { key: 'block_config_whatsapp', label: 'WhatsApp' },
            { key: 'block_config_companies', label: 'Empresas' },
            { key: 'block_config_sectors', label: 'Setores' },
            { key: 'block_config_categories', label: 'Categorias' },
            { key: 'block_config_team', label: 'Equipe' },
            { key: 'block_config_profiles', label: 'Perfis' },
            { key: 'block_config_schedules', label: 'Horários' },
            { key: 'block_config_bot', label: 'Bot & NPS' },
            { key: 'block_config_clients', label: 'Clientes' },
            { key: 'block_config_quickmsgs', label: 'Mensagens Rápidas' },
            { key: 'block_config_services', label: 'Serviços' }
        ]
    },
    {
        title: "Bloqueios: Relatórios",
        items: [
            { key: 'block_reports_team', label: 'Equipe' },
            { key: 'block_reports_evaluations', label: 'Avaliações' },
            { key: 'block_reports_clients', label: 'Por Cliente' },
            { key: 'block_reports_companies', label: 'Por Empresa' },
            { key: 'block_reports_categories', label: 'Por Categoria' },
            { key: 'block_reports_sectors', label: 'Por Setor' },
            { key: 'block_reports_external', label: 'Atend. Externo' }
        ]
    }
];

const DIAS_SEMANA = [
    { id: 'sun', label: 'Domingo' }, { id: 'mon', label: 'Segunda' },
    { id: 'tue', label: 'Terça' }, { id: 'wed', label: 'Quarta' },
    { id: 'thu', label: 'Quinta' }, { id: 'fri', label: 'Sexta' },
    { id: 'sat', label: 'Sábado' }
];

const ConfiguracoesScreen = ({ currentUser, companyData }) => {
    const [activeTab, setActiveTab] = useState(() => {
        const tab = sessionStorage.getItem('targetSettingsTab');
        if (tab) sessionStorage.removeItem('targetSettingsTab');
        return tab || 'clients';
    });
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const renderContent = () => {
        switch (activeTab) {
            case 'connection': return <ConnectionPanel currentUser={currentUser} />;
            case 'clients': return <ClientsPanel />;
            case 'companies': return <CompaniesPanel />;
            case 'integrations': return <IntegrationsPanel />;
            case 'services': return <ServicesPanel />;
            case 'sectors': return <SectorsPanel />;
            case 'users': return <UsersPanel />;
            case 'profiles': return <ProfilesPanel />;
            case 'schedules': return <SchedulesPanel />;
            case 'bot': return <BotPanel />;
            case 'categories': return <CategoriesPanel />;
            case 'quickmsgs': return <QuickMessagesPanel />;
            default: return <ClientsPanel />;
        }
    };

    const allTabs = [
        { id: 'clients', label: 'Clientes', icon: Users, block: 'block_config_clients' },
        { id: 'bot', label: 'Bot & NPS', icon: MessageSquare, block: 'block_config_bot' },
        { id: 'services', label: 'Serviços', icon: Briefcase, block: 'block_config_services' },
        { id: 'sectors', label: 'Setores', icon: Layers, block: 'block_config_sectors' },
        { id: 'categories', label: 'Categorias', icon: Tag, block: 'block_config_categories' },
        { id: 'users', label: 'Equipe', icon: UserCheck, block: 'block_config_team' },
        { id: 'profiles', label: 'Perfis', icon: Shield, block: 'block_config_profiles' },
        { id: 'schedules', label: 'Horários', icon: Clock, block: 'block_config_schedules' },
        { id: 'companies', label: 'Empresas', icon: Building, block: 'block_config_companies' },
        { id: 'integrations', label: 'Integrações', icon: Landmark, block: 'block_config_companies' },
        { id: 'quickmsgs', label: 'Rápidas', icon: Zap, block: 'block_config_quickmsgs' },
        { id: 'connection', label: 'WhatsApp', icon: Wifi, block: 'block_config_whatsapp' },
    ].filter(tab => {
        if (tab.id === 'integrations' && !companyData?.modules?.integracoes) return false;
        // Se for admin, vê tudo. Se não, verifica se TEM o bloqueio.
        if (currentUser?.role === 'admin' || currentUser?.permissions?.admin) return true;
        // Se block_... for true, esconde a aba
        return !currentUser?.permissions?.[tab.block];
    });

    return (
        <div className="flex h-full bg-gray-50 overflow-hidden font-sans relative">
            {/* SIDEBAR DESKTOP */}
            <div className="hidden md:flex w-64 bg-white border-r border-gray-200 flex-col shrink-0">
                <div className="p-6 border-b border-gray-100">
                    <h1 className="text-xl font-bold text-gray-800 flex items-center">Configurações</h1>
                </div>
                <nav className="flex-1 overflow-y-auto p-4 space-y-1 custom-scrollbar">
                    {allTabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${activeTab === tab.id ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'}`}
                        >
                            <tab.icon className={`w-5 h-5 mr-3 ${activeTab === tab.id ? 'text-blue-600' : 'text-gray-400'}`} />
                            {tab.label}
                        </button>
                    ))}
                </nav>
            </div>

            {/* HEADER MOBILE */}
            <div className="md:hidden absolute top-0 left-0 right-0 h-16 bg-white border-b z-20 flex items-center px-4 justify-between">
                <h1 className="text-lg font-bold text-gray-800">Configurações</h1>
                <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 text-gray-600">
                    <Menu className="w-6 h-6" />
                </button>
            </div>

            {/* MENU MOBILE OVERLAY */}
            {mobileMenuOpen && (
                <div className="md:hidden absolute top-16 left-0 right-0 bottom-0 bg-white z-30 p-4 overflow-y-auto">
                    {allTabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => { setActiveTab(tab.id); setMobileMenuOpen(false); }}
                            className={`w-full flex items-center px-4 py-4 text-base font-medium border-b ${activeTab === tab.id ? 'text-blue-700 bg-blue-50' : 'text-gray-600'}`}
                        >
                            <tab.icon className={`w-5 h-5 mr-3 ${activeTab === tab.id ? 'text-blue-600' : 'text-gray-400'}`} />
                            {tab.label}
                        </button>
                    ))}
                </div>
            )}

            {/* CONTEÚDO PRINCIPAL */}
            <div className="flex-1 overflow-y-auto p-4 md:p-8 custom-scrollbar mt-16 md:mt-0">
                {renderContent()}
            </div>
        </div>
    );
};

// ==================================================================================
// 1.5 GRUPOS DE CLIENTES
// ==================================================================================
const ClientGroupLinkerModal = ({ isOpen, onClose, group }) => {
    const [allClients, setAllClients] = useState([]);
    const [available, setAvailable] = useState([]);
    const [linked, setLinked] = useState([]);
    const [selectedAvail, setSelectedAvail] = useState([]);
    const [selectedLinked, setSelectedLinked] = useState([]);
    const [searchAvail, setSearchAvail] = useState('');
    const [searchLinked, setSearchLinked] = useState('');
    const [saving, setSaving] = useState(false);
    const [groupName, setGroupName] = useState('');

    useEffect(() => {
        if (!isOpen) return;
        setGroupName(group ? group.name : '');
        const fetchAll = async () => {
            try {
                const res = await api.get('/clients', { params: { limit: 9999 } });
                const clientsList = res.data.clients || res.data || [];
                setAllClients(clientsList);
                
                const linkedIds = group ? (group.clients || []).map(id => String(id)) : [];
                setLinked(clientsList.filter(c => linkedIds.includes(String(c._id || c.id))));
                setAvailable(clientsList.filter(c => !linkedIds.includes(String(c._id || c.id))));
            } catch (e) { console.error(e); }
        };
        fetchAll();
        setSelectedAvail([]);
        setSelectedLinked([]);
        setSearchAvail('');
        setSearchLinked('');
    }, [isOpen, group]);

    const toggleSelect = (id, list, setList) => {
        setList(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    const moveToLinked = () => {
        const toMove = available.filter(c => selectedAvail.includes(String(c._id || c.id)));
        setLinked(prev => [...prev, ...toMove]);
        setAvailable(prev => prev.filter(c => !selectedAvail.includes(String(c._id || c.id))));
        setSelectedAvail([]);
    };

    const moveAllToLinked = () => {
        const toMove = available.filter(c => c.name.toLowerCase().includes(searchAvail.toLowerCase()));
        setLinked(prev => [...prev, ...toMove]);
        setAvailable(prev => prev.filter(c => !toMove.map(x=>x._id||x.id).includes(c._id||c.id)));
        setSelectedAvail([]);
    };

    const moveToAvailable = () => {
        const toMove = linked.filter(c => selectedLinked.includes(String(c._id || c.id)));
        setAvailable(prev => [...prev, ...toMove]);
        setLinked(prev => prev.filter(c => !selectedLinked.includes(String(c._id || c.id))));
        setSelectedLinked([]);
    };

    const moveAllToAvailable = () => {
        const toMove = linked.filter(c => c.name.toLowerCase().includes(searchLinked.toLowerCase()));
        setAvailable(prev => [...prev, ...toMove]);
        setLinked(prev => prev.filter(c => !toMove.map(x=>x._id||x.id).includes(c._id||c.id)));
        setSelectedLinked([]);
    };

    const handleSave = async () => {
        if (!groupName.trim()) return alert("O nome do grupo  obrigatrio.");
        setSaving(true);
        try {
            const clientIds = linked.map(c => c._id || c.id);
            const payload = { name: groupName, clients: clientIds };
            if (group) {
                await api.put(`/client-groups/${group._id || group.id}`, payload);
            } else {
                await api.post('/client-groups', payload);
            }
            onClose(true);
        } catch (e) {
            alert('Erro ao salvar grupo.');
            console.error(e);
        } finally {
            setSaving(false);
        }
    };

    const filteredAvail = available.filter(c => c.name?.toLowerCase().includes(searchAvail.toLowerCase()) || c.phone?.includes(searchAvail));
    const filteredLinked = linked.filter(c => c.name?.toLowerCase().includes(searchLinked.toLowerCase()) || c.phone?.includes(searchLinked));

    return (
        <Modal isOpen={isOpen} onClose={() => onClose()} title={group ? "Editar Grupo" : "Novo Grupo"} hideFooter={true} size="max-w-5xl w-full">
            <div className="flex flex-col gap-4">
                <div>
                    <label className="font-bold text-sm mb-1 block text-gray-700">Nome do Grupo*</label>
                    <input 
                        value={groupName} 
                        onChange={e => setGroupName(e.target.value)}
                        className="w-full border border-gray-300 rounded p-2 focus:ring-2 focus:ring-blue-500"
                        placeholder="Ex: VIPs, Inadimplentes..."
                    />
                </div>
                
                <p className="text-sm text-gray-600">Selecione e mova os clientes para vincular ao grupo.</p>
                <div className="flex flex-col md:flex-row gap-4 items-stretch h-[400px]">
                    <div className="flex-1 border rounded-lg flex flex-col bg-gray-50 overflow-hidden">
                        <div className="bg-blue-600 text-white font-bold p-2 text-sm text-center">CLIENTES DISPONVEIS ({filteredAvail.length})</div>
                        <div className="p-2 border-b bg-white">
                            <div className="relative">
                                <Search className="w-4 h-4 absolute left-2 top-2.5 text-gray-400" />
                                <input value={searchAvail} onChange={e=>setSearchAvail(e.target.value)} placeholder="Buscar..." className="w-full pl-8 p-2 text-sm border rounded" />
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto p-2 bg-white">
                            {filteredAvail.map(c => (
                                <div key={c._id||c.id} onClick={() => toggleSelect(String(c._id||c.id), selectedAvail, setSelectedAvail)} className={`p-2 border-b cursor-pointer text-sm transition-colors flex justify-between items-center ${selectedAvail.includes(String(c._id||c.id)) ? 'bg-blue-100 border-blue-300 font-bold' : 'hover:bg-gray-50'}`}>
                                    <span>{c.name} <span className="text-xs text-gray-400">({c.phone})</span></span>
                                </div>
                            ))}
                            {filteredAvail.length === 0 && <p className="text-gray-400 text-xs text-center mt-4 italic">Nenhum cliente disponvel.</p>}
                        </div>
                    </div>

                    <div className="flex flex-col items-center justify-center gap-3 shrink-0 py-4">
                        <button onClick={moveAllToLinked} className="p-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow" disabled={filteredAvail.length === 0}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 5l7 7-7 7M5 5l7 7-7 7" /></svg>
                        </button>
                        <button onClick={moveToLinked} className="p-2 bg-gray-200 hover:bg-blue-100 text-blue-700 rounded-lg shadow" disabled={selectedAvail.length === 0}>
                            <ChevronRight className="w-4 h-4" />
                        </button>
                        <button onClick={moveToAvailable} className="p-2 bg-gray-200 hover:bg-red-100 text-red-700 rounded-lg shadow" disabled={selectedLinked.length === 0}>
                            <ChevronLeft className="w-4 h-4" />
                        </button>
                        <button onClick={moveAllToAvailable} className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg shadow" disabled={filteredLinked.length === 0}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" /></svg>
                        </button>
                    </div>

                    <div className="flex-1 border rounded-lg flex flex-col bg-gray-50 overflow-hidden border-green-200">
                        <div className="bg-green-600 text-white font-bold p-2 text-sm text-center">CLIENTES VINCULADOS ({filteredLinked.length})</div>
                        <div className="p-2 border-b bg-white">
                            <div className="relative">
                                <Search className="w-4 h-4 absolute left-2 top-2.5 text-gray-400" />
                                <input value={searchLinked} onChange={e=>setSearchLinked(e.target.value)} placeholder="Buscar..." className="w-full pl-8 p-2 text-sm border rounded" />
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto p-2 bg-white">
                            {filteredLinked.map(c => (
                                <div key={c._id||c.id} onClick={() => toggleSelect(String(c._id||c.id), selectedLinked, setSelectedLinked)} className={`p-2 border-b cursor-pointer text-sm transition-colors flex justify-between items-center ${selectedLinked.includes(String(c._id||c.id)) ? 'bg-green-100 border-green-300 font-bold' : 'hover:bg-gray-50'}`}>
                                    <span>{c.name} <span className="text-xs text-gray-400">({c.phone})</span></span>
                                </div>
                            ))}
                            {filteredLinked.length === 0 && <p className="text-gray-400 text-xs text-center mt-4 italic">Nenhum cliente vinculado.</p>}
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-3 pt-4 border-t mt-2">
                    <button onClick={() => onClose()} className="px-4 py-2 text-gray-600 hover:bg-gray-100 font-bold rounded-lg">Cancelar</button>
                    <button onClick={handleSave} disabled={saving} className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg flex items-center gap-2">
                        {saving ? 'Salvando...' : <><CheckCircle className="w-4 h-4" /> Salvar Grupo</>}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

const ClientGroupsSubPanel = () => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [linkerOpen, setLinkerOpen] = useState(false);
    const [editingGroup, setEditingGroup] = useState(null);

    const loadGroups = async () => {
        setLoading(true);
        try {
            const res = await api.get('/client-groups');
            setGroups(res.data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadGroups();
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Deseja realmente excluir este grupo? Os clientes no sero apagados.")) return;
        try {
            await api.delete(`/client-groups/${id}`);
            loadGroups();
        } catch (e) {
            alert('Erro ao excluir grupo.');
        }
    };

    const handleOpenLinker = (group = null) => {
        setEditingGroup(group);
        setLinkerOpen(true);
    };

    return (
        <div className="mt-4">
            <div className="flex justify-between items-center mb-4">
                <p className="text-gray-600">Gerencie os grupos e vincule clientes a eles.</p>
                <button onClick={() => handleOpenLinker()} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded font-bold shadow-sm flex items-center">
                    <Plus className="w-4 h-4 mr-2" /> Novo Grupo
                </button>
            </div>

            <div className="bg-white border rounded-xl shadow-sm overflow-hidden">
                <table className="w-full text-left text-sm">
                    <thead className="bg-gray-50 border-b text-gray-600">
                        <tr>
                            <th className="p-4 w-1/3">Nome do Grupo</th>
                            <th className="p-4 w-1/3 text-center">Clientes Vinculados</th>
                            <th className="p-4 text-right">Açes</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y">
                        {loading ? (
                            <tr><td colSpan="3" className="p-8 text-center text-gray-400">Carregando...</td></tr>
                        ) : groups.length === 0 ? (
                            <tr><td colSpan="3" className="p-8 text-center text-gray-400 italic">Nenhum grupo cadastrado.</td></tr>
                        ) : (
                            groups.map(g => (
                                <tr key={g._id || g.id} className="hover:bg-gray-50">
                                    <td className="p-4 font-bold text-gray-800">{g.name}</td>
                                    <td className="p-4 text-center">
                                        <span className="bg-blue-100 text-blue-800 font-bold px-3 py-1 rounded-full text-xs">
                                            {g.clients?.length || 0}
                                        </span>
                                    </td>
                                    <td className="p-4 text-right">
                                        <button onClick={() => handleOpenLinker(g)} className="text-blue-600 hover:bg-blue-50 p-2 rounded mr-1"><Edit2 className="w-4 h-4" /></button>
                                        <button onClick={() => handleDelete(g._id || g.id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 className="w-4 h-4" /></button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {linkerOpen && (
                <ClientGroupLinkerModal 
                    isOpen={linkerOpen} 
                    group={editingGroup} 
                    onClose={(didSave) => {
                        setLinkerOpen(false);
                        if (didSave) loadGroups();
                    }} 
                />
            )}
        </div>
    );
};

// ==================================================================================
// 1. CLIENTES (COM OBRIGATORIEDADE)
// ==================================================================================
const ClientsPanel = () => {
    const [activeTab, setActiveTab] = useState('clients');
    const [clients, setClients] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [searchCompany, setSearchCompany] = useState(''); // 🆕 Filtro Inteligente de Empresa
    const [selectedGroupId, setSelectedGroupId] = useState('all'); // Novo estado
    const [clientGroups, setClientGroups] = useState([]); // Novo estado
    const [showBlocked, setShowBlocked] = useState(false); // ç🆕 Filtro de Bloqueados
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [importModalOpen, setImportModalOpen] = useState(false); // ç🆕 Estado do Modal de Importação
    const [editingClient, setEditingClient] = useState(null);
    const [isRegisterRequired, setIsRegisterRequired] = useState(false);
    const fileInputRef = useRef(null);

    const downloadTemplate = () => {
        const headers = ['name', 'phone', 'company', 'lid', 'email', 'notes', 'ignoreMetrics'];
        const example = ['João Silva', '5511999999999', 'Empresa Exemplo', 'LID123', 'joao@email.com', 'Cliente VIP', 'false'];
        const csvContent = "data:text/csv;charset=utf-8," + headers.join(",") + "\n" + example.join(",");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "modelo_importacao_clientes.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            loadClients();
        }, 300); // 🆕 Debounce reduzido para agilizar busca
        return () => clearTimeout(timeoutId);
    }, [search, searchCompany, page, showBlocked, selectedGroupId]); // 🆕 Recarrega ao mudar filtro

    useEffect(() => {
        loadSettings();
        loadGroups();
    }, []);

    const loadGroups = async () => {
        try {
            const res = await api.get('/client-groups');
            setClientGroups(Array.isArray(res.data) ? res.data : []);
        } catch (e) { console.error("Erro ao buscar grupos", e); }
    };

    const loadSettings = async () => {
        try {
            const res = await api.get('/company/status');
            setIsRegisterRequired(res.data.settings?.clientRegisterRequired || false);
        } catch (e) { }
    };

    const toggleRequirement = async (e) => {
        const checked = e.target.checked;
        setIsRegisterRequired(checked);
        try {
            await api.put('/company/settings/clients', { clientRegisterRequired: checked });
        } catch (error) {
            setIsRegisterRequired(!checked);
            alert("Erro ao salvar configuração.");
        }
    };

    const loadClients = async () => {
        setLoading(true);
        try {
            const res = await api.get('/clients', {
                params: {
                    search,
                    searchCompany, // 🆕 Passando novo parâmetro
                    page,
                    limit: 50,
                    showBlocked: showBlocked ? 'true' : 'false', // ç🆕 Envia filtro como string
                    groupId: selectedGroupId
                }
            });
            setClients(Array.isArray(res.data.clients) ? res.data.clients : []);
            setTotal(res.data.total || 0);
        } catch (e) { console.error(e); setClients([]); }
        finally { setLoading(false); }
    };

    const toggleBlock = async (client) => {
        if (!window.confirm(`Deseja ${client.isBlocked ? 'desbloquear' : 'bloquear'} este cliente?`)) return;
        try {
            await api.put(`/clients/${client._id || client.id}`, {
                ...client,
                isBlocked: !client.isBlocked
            });
            loadClients();
        } catch (e) { alert("Erro ao alterar status do cliente."); }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("ATENÇ?ÃO: Tem certeza que deseja excluir este cliente? O histórico será mantido mas o vínculo pode ser perdido.")) return;
        try {
            await api.delete(`/clients/${id}`);
            alert("Cliente excluído com sucesso!");
            loadClients();
        } catch (e) { alert("Erro ao excluir cliente."); }
    };

    const handleImportCSV = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        Papa.parse(file, {
            header: true, skipEmptyLines: true,
            complete: async (results) => {
                const validClients = results.data.filter(c => c.name && c.phone);
                try {
                    await api.post('/clients/import', { clients: validClients });
                    alert(`${validClients.length} clientes importados!`);
                    loadClients();
                } catch (err) { alert("Erro na importação."); }
            }
        });
    };

    const openEdit = (c) => { setEditingClient(c); setModalOpen(true); };

    return (
        <div className="max-w-6xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 flex items-center text-gray-800"><Users className="mr-2 text-blue-600" /> Gestão de Clientes</h2>

            {/* TAB NAVIGATION */}
            <div className="flex justify-between items-center border-b border-gray-200 mb-6">
                <div className="flex space-x-1">
                    <button 
                        onClick={() => setActiveTab('clients')}
                        className={`py-2 px-4 font-semibold text-sm border-b-2 transition-colors ${activeTab === 'clients' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                    >
                        Clientes
                    </button>
                    <button 
                        onClick={() => setActiveTab('groups')}
                        className={`py-2 px-4 font-semibold text-sm border-b-2 transition-colors ${activeTab === 'groups' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                    >
                        Grupos
                    </button>
                </div>

                {/* BOTÕES NOVO E IMPORTAR */}
                {activeTab === 'clients' && (
                    <div className="flex items-center gap-2 mb-2">
                        <button onClick={() => { setEditingClient(null); setModalOpen(true) }} className="bg-blue-600 text-white px-4 py-2 rounded flex items-center hover:bg-blue-700 transition-colors"><PlusCircle className="w-4 h-4 mr-2" /> Novo</button>
                        <button onClick={() => setImportModalOpen(true)} className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center transition-colors"><Upload className="w-4 h-4 mr-2" /> Importar</button>
                        <input type="file" ref={fileInputRef} onChange={handleImportCSV} className="hidden" accept=".csv" />
                    </div>
                )}
            </div>

            {activeTab === 'clients' ? (
                <>

            {/* PAINEL OBRIGATORIEDADE */}
            <div className="bg-orange-50 p-4 rounded-lg shadow-sm border border-orange-200 flex justify-between items-center mb-6">
                <div className="flex items-center">
                    <AlertCircle className="w-6 h-6 text-orange-600 mr-3" />
                    <div>
                        <h3 className="font-bold text-orange-800">Obrigar Cadastro Completo</h3>
                        <p className="text-sm text-orange-700">Se ativo, o atendente será obrigado a informar <strong>Nome, Telefone e Empresa</strong> antes de Finalizar o atendimento.</p>
                    </div>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" checked={isRegisterRequired} onChange={toggleRequirement} />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-orange-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
            </div>

            <div className="flex flex-col md:flex-row justify-between mb-4 gap-4 items-center">
                <div className="flex flex-1 w-full gap-2">
                    <div className="relative flex-1">
                        <input
                            placeholder="Buscar por nome ou telefone..."
                            value={search}
                            onChange={e => { setSearch(e.target.value); setPage(1); }}
                            className="w-full border p-2 pl-9 rounded shadow-sm"
                        />
                        <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
                    </div>
                    <select
                        value={selectedGroupId}
                        onChange={(e) => { setSelectedGroupId(e.target.value); setPage(1); }}
                        className="border p-2 rounded shadow-sm bg-white text-gray-700 min-w-[150px]"
                    >
                        <option value="all">Todos os Grupos</option>
                        {clientGroups.map(g => (
                            <option key={g._id || g.id} value={g._id || g.id}>{g.name}</option>
                        ))}
                    </select>
                    <div className="relative flex-1">
                        <input
                            placeholder="Buscar por Empresa..."
                            value={searchCompany}
                            onChange={e => { setSearchCompany(e.target.value); setPage(1); }}
                            className="w-full border p-2 pl-9 rounded shadow-sm"
                        />
                        <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <label className="flex items-center space-x-2 text-sm text-gray-600 bg-white p-2 rounded border cursor-pointer select-none">
                        <input
                            type="checkbox"
                            checked={showBlocked}
                            onChange={e => { setShowBlocked(e.target.checked); setPage(1); }}
                            className="rounded text-red-600 focus:ring-red-500"
                        />
                        <span className={showBlocked ? "font-bold text-red-600" : ""}>Mostrar Bloqueados</span>
                    </label>
                </div>
            </div>
            <div className="bg-white rounded shadow overflow-hidden">
                <table className="w-full text-left text-sm">
                    <thead className="bg-gray-50 border-b"><tr><th className="p-4">Nome</th><th className="p-4 hidden md:table-cell">Telefone</th><th className="p-4 hidden md:table-cell">Empresa</th><th className="p-4 hidden md:table-cell">Grupo</th><th className="p-4 text-right">Ações</th></tr></thead>
                    <tbody className="divide-y">
                        {clients.map(c => (
                            <tr key={c._id || c.id} className={`hover:bg-gray-50 transition-colors ${c.isBlocked ? 'bg-red-50 border-l-4 border-red-500' : ''}`}>
                                <td className="p-4">
                                    <div className="flex items-center gap-2">
                                        {c.isBlocked && <Ban className="w-4 h-4 text-red-600" title="Cliente Bloqueado" />}
                                        <div className="font-bold">{c.name}</div>
                                    </div>
                                    <div className="md:hidden text-xs text-gray-500">{c.phone}</div>
                                    {c.ignoreMetrics && <span className="text-[10px] bg-gray-200 text-gray-600 px-1 rounded ml-1">Sem Métricas</span>}
                                </td>
                                <td className="p-4 hidden md:table-cell text-gray-500">{c.phone}</td>
                                <td className="p-4 hidden md:table-cell text-gray-500">
                                    {c.company || '-'}
                                    {c.ignoreMetrics && <div className="text-xs text-orange-500 font-bold mt-1">Ignorar Métricas</div>}
                                </td>
                                <td className="p-4 hidden md:table-cell text-gray-500">
                                    {c.groupNames || '-'}
                                </td>
                                <td className="p-4 text-right flex justify-end gap-2">
                                    <button
                                        onClick={() => toggleBlock(c)}
                                        className={`p-2 rounded hover:opacity-80 ${c.isBlocked ? 'text-green-600 bg-green-50' : 'text-red-600 bg-red-50'}`}
                                        title={c.isBlocked ? "Desbloquear" : "Bloquear"}
                                    >
                                        <Ban className="w-4 h-4" />
                                    </button>
                                    <button onClick={() => openEdit(c)} className="text-blue-600 hover:bg-blue-50 p-2 rounded"><Edit2 className="w-4 h-4" /></button>
                                    <button onClick={() => handleDelete(c._id || c.id)} className="text-red-600 hover:bg-red-50 p-2 rounded" title="Excluir"><Trash2 className="w-4 h-4" /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="mt-4 flex justify-between items-center text-xs text-gray-500">
                <span>Total: {total}</span>
                <div className="flex gap-2">
                    <button disabled={page === 1} onClick={() => setPage(p => p - 1)} className="px-3 py-1 border rounded disabled:opacity-50">Anterior</button>
                    <span className="px-3 py-1 bg-white border rounded">{page}</span>
                    <button disabled={clients.length < 50} onClick={() => setPage(p => p + 1)} className="px-3 py-1 border rounded disabled:opacity-50">Próxima</button>
                </div>
            </div>
            <ClientFormModal
                isOpen={modalOpen}
                onClose={() => { setModalOpen(false); setEditingClient(null); }}
                onSuccess={() => { loadClients(); }}
                clientId={editingClient?._id || editingClient?.id}
                initialName={editingClient?.name}
                initialPhone={editingClient?.phone}
                initialLid={editingClient?.lid}
                initialCompany={editingClient?.company}
                initialEmail={editingClient?.email}
                initialNotes={editingClient?.notes}
                initialIgnoreMetrics={editingClient?.ignoreMetrics}
                initialUsePreferredAgent={editingClient?.usePreferredAgent}
                initialPreferredAgentId={editingClient?.preferredAgentId}
            />

            {/* MODAL DE INSTRUÇ?ç.ES DE IMPORTAÇ?ÃO */}
            <Modal
                isOpen={importModalOpen}
                onClose={() => setImportModalOpen(false)}
                title="Importar Clientes via CSV"
                confirmText="Selecionar Arquivo"
                onConfirm={() => fileInputRef.current.click()}
            >
                <div className="space-y-4 text-sm text-gray-600">
                    <p>O arquivo deve estar no formato <strong>.CSV</strong> (separado por vírgulas) e conter as seguintes colunas:</p>

                    <div className="bg-gray-50 p-3 rounded border border-gray-200 font-mono text-xs overflow-x-auto">
                        <p className="font-bold mb-1">Cabeçalho (obrigatório):</p>
                        <p className="text-blue-600">name,phone,company,lid,email,notes,ignoreMetrics</p>
                        <p className="font-bold mt-2 mb-1">Exemplo de dados:</p>
                        <p className="text-gray-500">João Silva,5511999999999,Minha Empresa,LID123,joao@email.com,Nota opcional,false</p>
                    </div>

                    <ul className="list-disc list-inside space-y-1">
                        <li><strong>name:</strong> Nome do cliente (Obrigatório)</li>
                        <li><strong>phone:</strong> Telefone com DDI (ex: 5511...) (Obrigatório)</li>
                        <li><strong>company:</strong> Nome da empresa (Opcional)</li>
                        <li><strong>lid:</strong> ID interno/Legado (Opcional)</li>
                        <li><strong>ignoreMetrics:</strong> 'true' ou 'false' (Opcional)</li>
                    </ul>

                    <div className="pt-2">
                        <button
                            onClick={downloadTemplate}
                            className="text-blue-600 hover:text-blue-800 font-bold flex items-center gap-1 underline"
                        >
                            <Upload className="w-3 h-3" /> Baixar Modelo Exemplo (.csv)
                        </button>
                    </div>

                    <div className="bg-yellow-50 p-3 rounded border border-yellow-100 flex items-start mt-2">
                        <AlertCircle className="w-5 h-5 text-yellow-600 mr-2 shrink-0" />
                        <span className="text-xs text-yellow-800">
                            Certifique-se de que o arquivo esteja codificado em <strong>UTF-8</strong> para evitar problemas com acentos.
                        </span>
                    </div>
                </div>
            </Modal>
            </>
            ) : (
                <ClientGroupsSubPanel />
            )}
        </div>
    );
};

// ==================================================================================
// 2. EQUIPE
// ==================================================================================
const UsersPanel = () => {
    const [users, setUsers] = useState([]);
    const [profiles, setProfiles] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [sectors, setSectors] = useState([]);
    const [clientGroups, setClientGroups] = useState([]); // Novo estado
    const [companyInfo, setCompanyInfo] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [editUser, setEditUser] = useState(null);
    const [form, setForm] = useState({ name: '', email: '', password: '', profileId: '', workScheduleId: '', sectorId: '', clientGroups: [] });

    useEffect(() => { loadData(); }, []);

    const loadData = async () => {
        try {
            const [uRes, pRes, sRes, secRes, cRes, cgRes] = await Promise.all([
                api.get('/users'),
                api.get('/profiles'),
                api.get('/work-schedules'),
                api.get('/sectors'),
                api.get('/company/status'),
                api.get('/client-groups')
            ]);
            setUsers(Array.isArray(uRes.data) ? uRes.data : []);
            setProfiles(Array.isArray(pRes.data) ? pRes.data : []);
            setSchedules(Array.isArray(sRes.data) ? sRes.data : []);
            setSectors(Array.isArray(secRes.data) ? secRes.data : []);
            setCompanyInfo(cRes.data);
            setClientGroups(Array.isArray(cgRes.data) ? cgRes.data : []);
        } catch (e) { console.error(e); }
    };

    const handleSave = async () => {
        try {
            if (editUser) await api.put(`/users/${editUser.id || editUser._id}`, form);
            else await api.post('/users', form);
            setModalOpen(false); loadData();
        } catch (e) { alert("Erro ao salvar usuário."); }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Remover este usuário?")) return;
        await api.delete(`/users/${id}`);
        loadData();
    };

    const openModal = (u = null) => {
        if (u) {
            setEditUser(u);
            setForm({ name: u.name, email: u.email, password: '', profileId: u.profileId || '', workScheduleId: u.workScheduleId || '', sectorId: u.sectorId || '', clientGroups: u.clientGroups || [] });
        } else {
            setEditUser(null);
            setForm({ name: '', email: '', password: '', profileId: '', workScheduleId: '', sectorId: '', clientGroups: [] });
        }
        setModalOpen(true);
    };

    const usersLimit = companyInfo?.usersLimit || 3;
    const isLimitReached = users.length >= usersLimit;

    return (
        <div className="max-w-6xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800 flex items-center"><UserCheck className="mr-2 text-blue-600" /> Equipe</h2>
                {isLimitReached ? (
                    <button onClick={() => window.location.href = '/assinatura'} className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg flex items-center font-bold shadow-md transition-all animate-pulse" title={`Limite de ${usersLimit} usuários atingido. Faça upgrade!`}>
                        <Zap className="w-4 h-4 mr-2" /> Fazer Upgrade ({users.length}/{usersLimit})
                    </button>
                ) : (
                    <button onClick={() => openModal()} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center transition-colors">
                        <PlusCircle className="w-4 h-4 mr-2" /> Adicionar Membro ({users.length}/{usersLimit})
                    </button>
                )}
            </div>
            <div className="bg-white rounded-lg shadow border overflow-hidden">
                <table className="w-full text-left text-sm">
                    <thead className="bg-gray-50 border-b text-gray-500 uppercase text-xs">
                        <tr><th className="p-4">Nome</th><th className="p-4 hidden md:table-cell">Email</th><th className="p-4">Perfil</th><th className="p-4 text-right">Ações</th></tr>
                    </thead>
                    <tbody className="divide-y">
                        {users.map(u => (
                            <tr key={u.id || u._id} className="hover:bg-gray-50">
                                <td className="p-4 font-bold">{u.name}</td>
                                <td className="p-4 hidden md:table-cell text-gray-500">{u.email}</td>
                                <td className="p-4"><span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-bold">{profiles.find(p => (p.id || p._id) === u.profileId)?.name || 'Padrão'}</span></td>
                                <td className="p-4 text-right">
                                    <button onClick={() => openModal(u)} className="text-blue-600 hover:bg-blue-50 p-2 rounded mr-1"><Edit2 className="w-4 h-4" /></button>
                                    <button onClick={() => handleDelete(u.id || u._id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 className="w-4 h-4" /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editUser ? "Editar Usuário" : "Novo Usuário"} confirmText="Salvar" onConfirm={handleSave}>
                <div className="space-y-4">
                    <input className="w-full p-2 border rounded" placeholder="Nome Completo" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                    <input className="w-full p-2 border rounded" placeholder="E-mail" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required type="email" />
                    <input className="w-full p-2 border rounded" placeholder="Senha (Deixe em branco para manter)" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} type="password" />
                    <div className="grid grid-cols-2 gap-4">
                        <div><label className="text-xs font-bold text-gray-500 mb-1 block">Perfil</label><select className="w-full p-2 border rounded bg-white" value={form.profileId} onChange={e => setForm({ ...form, profileId: e.target.value })}><option value="">Selecione...</option>{profiles.map(p => <option key={p.id || p._id} value={p.id || p._id}>{p.name}</option>)}</select></div>
                        <div><label className="text-xs font-bold text-gray-500 mb-1 block">Setor</label><select className="w-full p-2 border rounded bg-white" value={form.sectorId} onChange={e => setForm({ ...form, sectorId: e.target.value })}><option value="">Global</option>{sectors.map(s => <option key={s.id || s._id} value={s.id || s._id}>{s.name}</option>)}</select></div>
                    </div>
                    <div><label className="text-xs font-bold text-gray-500 mb-1 block">Horário</label><select className="w-full p-2 border rounded bg-white" value={form.workScheduleId} onChange={e => setForm({ ...form, workScheduleId: e.target.value })}><option value="">Livre (24h)</option>{schedules.map(s => <option key={s.id || s._id} value={s.id || s._id}>{s.name}</option>)}</select></div>
                    
                    <div>
                        <label className="text-xs font-bold text-gray-500 mb-1 block">Grupos de Clientes</label>
                        <div className="border rounded p-3 max-h-40 overflow-y-auto bg-gray-50 flex flex-col gap-2">
                            {clientGroups.length === 0 && <span className="text-xs text-gray-500">Nenhum grupo cadastrado.</span>}
                            {clientGroups.map(g => {
                                const id = g._id || g.id;
                                const isChecked = form.clientGroups.includes(id);
                                return (
                                    <label key={id} className="flex items-center gap-2 cursor-pointer text-sm">
                                        <input 
                                            type="checkbox" 
                                            checked={isChecked} 
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setForm(prev => {
                                                    const current = new Set(prev.clientGroups);
                                                    if (checked) current.add(id); else current.delete(id);
                                                    return { ...prev, clientGroups: Array.from(current) };
                                                });
                                            }} 
                                            className="rounded text-blue-600"
                                        />
                                        {g.name}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

// ==================================================================================
// 3. BOT & NPS (ATUALIZADO PARA GRAVAR CORRETAMENTE)
// ==================================================================================
const BotPanel = () => {
    const [config, setConfig] = useState({});
    const [clientGroups, setClientGroups] = useState([]);
    const [newWelcome, setNewWelcome] = useState({ text: '', startTime: '00:00', endTime: '23:59', days: [], groupId: '' });

    useEffect(() => { load(); }, []);

    const load = async () => {
        try {
            const res = await api.get('/settings/bot');
            setConfig(res.data || {});
            const groupsRes = await api.get('/client-groups');
            setClientGroups(groupsRes.data || []);
        } catch (e) { }
    };

    const save = async (data) => {
        const updated = { ...config, ...data };
        setConfig(updated);
        await api.put('/settings/bot', updated);
    };

    const addWelcome = async () => {
        if (!newWelcome.text || newWelcome.days.length === 0) return alert("Preencha texto e dias");
        const updated = [...(config.welcomeMessages || []), { ...newWelcome, id: Date.now().toString() }];
        await save({ welcomeMessages: updated });
        setNewWelcome({ text: '', startTime: '00:00', endTime: '23:59', days: [], groupId: '' });
    };

    const toggleDay = (dayId) => {
        const days = newWelcome.days.includes(dayId) ? newWelcome.days.filter(d => d !== dayId) : [...newWelcome.days, dayId];
        setNewWelcome({ ...newWelcome, days });
    };

    return (
        <div className="max-w-4xl mx-auto space-y-8">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center"><MessageSquare className="mr-2 text-blue-600" /> Automação e NPS</h2>

            {/* SEÇ?ÃO: PROTOCOLO */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex justify-between items-center">
                <div>
                    <h3 className="font-bold text-gray-800 flex items-center"><Hash className="w-5 h-5 mr-2 text-blue-600" /> Protocolo</h3>
                    <p className="text-sm text-gray-500 mt-1">Gerar e enviar número de protocolo automaticamente.</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox" className="sr-only peer"
                        checked={!!config.protocolConfig?.isActive}
                        onChange={e => save({ protocolConfig: { ...config.protocolConfig, isActive: e.target.checked } })}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-green-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
            </div>

            {/* GRID: MENSAGEM DE PAUSA E ENCERRAMENTO */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* CONFIG: MENSAGEM DE ENCERRAMENTO (CORRIGIDA) */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col h-full">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="font-bold text-gray-800 flex items-center">
                            <StopCircle className="w-5 h-5 mr-2 text-red-600" /> Encerramento
                        </h3>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={!!config.endMessage?.isActive}
                                onChange={e => {
                                    // 🚀 FORÇ?A A ATUALIZAÇ?ÃO COMPLETA DO OBJETO
                                    const currentEnd = config.endMessage || { text: '' };
                                    save({ endMessage: { text: currentEnd.text, isActive: e.target.checked } });
                                }}
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-green-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                        </label>
                    </div>
                    <textarea
                        className={`w-full border p-3 rounded-lg text-sm outline-none resize-none flex-1 ${!config.endMessage?.isActive ? 'bg-gray-50 opacity-50' : ''}`}
                        rows="3"
                        value={config.endMessage?.text || ''}
                        onChange={e => setConfig({ ...config, endMessage: { ...config.endMessage, text: e.target.value } })}
                        placeholder="Ex: Atendimento finalizado. Obrigado!"
                    />
                    <button
                        onClick={() => save({ endMessage: config.endMessage })}
                        className="mt-4 w-full py-2 rounded text-sm font-bold text-white transition-colors bg-red-600 hover:bg-red-700"
                    >
                        Salvar
                    </button>
                </div>

                {/* CONFIG: MENSAGEM DE PAUSA */}
                <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col h-full">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="font-bold text-gray-800 flex items-center">
                            <PauseCircle className="w-5 h-5 mr-2 text-orange-600" /> Pausa
                        </h3>
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                className="sr-only peer"
                                checked={!!config.pauseMessage?.isActive}
                                onChange={e => {
                                    const currentPause = config.pauseMessage || { text: '' };
                                    save({ pauseMessage: { text: currentPause.text, isActive: e.target.checked } });
                                }}
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-green-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                        </label>
                    </div>
                    <textarea
                        className={`w-full border p-3 rounded-lg text-sm outline-none resize-none flex-1 ${!config.pauseMessage?.isActive ? 'bg-gray-50 opacity-50' : ''}`}
                        rows="3"
                        value={config.pauseMessage?.text || ''}
                        onChange={e => setConfig({ ...config, pauseMessage: { ...config.pauseMessage, text: e.target.value } })}
                        placeholder="Ex: Pausa..."
                    />
                    <button
                        onClick={() => save({ pauseMessage: config.pauseMessage })}
                        className="mt-4 w-full py-2 rounded text-sm font-bold text-white transition-colors bg-orange-600 hover:bg-orange-700"
                    >
                        Salvar
                    </button>
                </div>
            </div>

            {/* SEÇ?ÃO: NPS */}
            <div className="bg-white p-6 rounded-lg shadow-sm border border-yellow-200">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-bold text-gray-800 flex items-center"><Star className="w-5 h-5 mr-2 text-yellow-500 fill-yellow-500" /> Pesquisa de Satisfação (NPS)</h3>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" className="sr-only peer" checked={!!config.evaluationActive} onChange={e => save({ evaluationActive: e.target.checked })} />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-yellow-500 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                    </label>
                </div>
                <textarea className="w-full border p-3 rounded-lg text-sm outline-none" rows="2" value={config.evaluationMessage || ''} onChange={e => setConfig({ ...config, evaluationMessage: e.target.value })} placeholder="Ex: Avalie de 0 a 10..." />
                <button onClick={() => save({ evaluationMessage: config.evaluationMessage })} className="mt-2 bg-yellow-600 text-white px-4 py-2 rounded text-sm font-bold">Salvar Texto</button>
            </div>

            {/* SEÇ?ÃO: BOAS VINDAS */}
            <div className="bg-white p-6 rounded-lg shadow-sm border">
                <div className="flex justify-between items-center mb-4 border-b pb-4">
                    <h3 className="font-bold text-gray-800">Mensagens de Boas-Vindas</h3>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" className="sr-only peer" checked={!!config.welcomeMessagesActive} onChange={e => save({ welcomeMessagesActive: e.target.checked })} />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-green-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                    </label>
                </div>
                <div className={`transition-opacity ${config.welcomeMessagesActive ? 'opacity-100' : 'opacity-50 pointer-events-none select-none'}`}>
                    <div className="bg-gray-50 p-4 rounded mb-4 border border-blue-100">
                        <textarea placeholder="Digite a mensagem..." value={newWelcome.text} onChange={e => setNewWelcome({ ...newWelcome, text: e.target.value })} className="w-full p-2 border rounded mb-3 text-sm" rows="2"></textarea>
                        <div className="mb-3">
                            <select value={newWelcome.groupId || ''} onChange={e => setNewWelcome({ ...newWelcome, groupId: e.target.value })} className="w-full border p-2 rounded text-sm bg-white outline-none">
                                <option value="">Todos os clientes (Sem Grupo Específico)</option>
                                {clientGroups.map(g => <option key={g._id} value={g._id}>{g.name}</option>)}
                            </select>
                        </div>
                        <div className="flex flex-wrap gap-2 mb-3">
                            {DIAS_SEMANA.map(d => (
                                <button key={d.id} onClick={() => toggleDay(d.id)} className={`px-2 py-1 text-xs rounded border ${newWelcome.days.includes(d.id) ? 'bg-blue-600 text-white' : 'bg-white text-gray-600'}`}>{d.label}</button>
                            ))}
                        </div>
                        <div className="flex gap-2 items-center">
                            <input type="time" value={newWelcome.startTime} onChange={e => setNewWelcome({ ...newWelcome, startTime: e.target.value })} className="border p-1 rounded text-sm" />
                            <span className="text-gray-500 text-xs">até</span>
                            <input type="time" value={newWelcome.endTime} onChange={e => setNewWelcome({ ...newWelcome, endTime: e.target.value })} className="border p-1 rounded text-sm" />
                            <button onClick={addWelcome} className="bg-green-600 text-white px-4 py-1 rounded text-sm font-bold ml-auto">Adicionar</button>
                        </div>
                    </div>
                    <div className="space-y-2">
                        {(config.welcomeMessages || []).map(msg => (
                            <div key={msg.id} className="border p-3 rounded flex justify-between bg-white items-center">
                                <div>
                                    <p className="font-medium text-sm">{msg.text}</p>
                                    <p className="text-xs text-blue-600 mt-1 flex items-center gap-2">
                                        <span>{msg.days.map(d => DIAS_SEMANA.find(x => x.id === d)?.label.substring(0, 3) || d).join(', ')} | {msg.startTime} às {msg.endTime}</span>
                                        {msg.groupId && <span className="px-2 py-0.5 bg-indigo-100 text-indigo-700 font-medium rounded-full">Grupo: {clientGroups.find(g => g._id === msg.groupId)?.name || 'Excluído'}</span>}
                                    </p>
                                </div>
                                <button onClick={async () => { const up = config.welcomeMessages.filter(m => m.id !== msg.id); await save({ welcomeMessages: up }); }} className="text-red-500 p-2"><Trash2 className="w-4 h-4" /></button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
// ==================================================================================
// 4. SETORES
// ==================================================================================
const SectorsPanel = () => {
    const [sectors, setSectors] = useState([]);
    const [name, setName] = useState('');
    const [active, setActive] = useState(false);

    useEffect(() => { load(); }, []);
    const load = async () => {
        const res = await api.get('/sectors'); setSectors(res.data || []);
        const conf = await api.get('/settings/bot'); setActive(conf.data.sectorsActive || false);
    };
    const toggleActive = async (val) => { setActive(val); await api.put('/settings/bot', { sectorsActive: val }); };
    const add = async () => { if (name) { await api.post('/sectors', { name }); setName(''); load(); } };
    const del = async (id) => { await api.delete(`/sectors/${id}`); load(); };

    return (
        <div className="max-w-2xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold flex items-center text-gray-800"><Layers className="mr-2 text-blue-600" /> Setores de Atendimento</h2>
                <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-gray-600">Bot de Setores:</span>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" className="sr-only peer" checked={active} onChange={e => toggleActive(e.target.checked)} />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-blue-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                    </label>
                </div>
            </div>
            <div className="flex gap-2 mb-4">
                <input value={name} onChange={e => setName(e.target.value)} className="flex-1 border p-2 rounded" placeholder="Nome do Setor (ex: Financeiro)" />
                <button onClick={add} className="bg-blue-600 text-white px-4 rounded font-bold">Adicionar</button>
            </div>
            <div className="bg-white rounded shadow border divide-y">
                {sectors.map((i, idx) => (
                    <div key={i._id || i.id} className="p-3 flex justify-between items-center hover:bg-gray-50">
                        <span className="font-bold text-gray-800">{idx + 1}. {i.name}</span>
                        <button onClick={() => del(i._id || i.id)} className="text-red-500 p-2 hover:bg-red-50 rounded"><Trash2 className="w-4 h-4" /></button>
                    </div>
                ))}
            </div>
        </div>
    );
};

// ==================================================================================
// 5. OUTRAS ABAS
// ==================================================================================

const ProfilesPanel = () => {
    const [profiles, setProfiles] = useState([]);
    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState({ name: '', permissions: {} });

    useEffect(() => { load(); }, []);
    const load = async () => { try { const res = await api.get('/profiles'); setProfiles(res.data || []); } catch (e) { } };

    const handleSave = async () => {
        try {
            if (editing === 'new') await api.post('/profiles', form);
            else await api.put(`/profiles/${editing}`, form);
            setEditing(null); load();
        } catch (e) { alert("Erro ao salvar perfil"); }
    };

    const togglePerm = (key) => {
        setForm(prev => ({ ...prev, permissions: { ...prev.permissions, [key]: !prev.permissions[key] } }));
    };

    if (editing) {
        return (
            <div className="bg-white p-6 rounded-lg shadow border max-w-2xl mx-auto">
                <h3 className="font-bold text-lg mb-4">Editor de Perfil</h3>
                <input type="text" placeholder="Nome do Perfil" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full p-3 border rounded mb-6" />
                <div className="space-y-6 mb-6 h-96 overflow-y-auto custom-scrollbar border p-2 rounded bg-gray-50">
                    {PERMISSIONS_GROUPS.map((group, gIdx) => (
                        <div key={gIdx} className="bg-white p-3 rounded shadow-sm border">
                            <h4 className="font-bold text-gray-800 mb-2 text-sm uppercase flex items-center">
                                <Shield className="w-3 h-3 mr-1" /> {group.title}
                            </h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                {group.items.map(perm => (
                                    <label key={perm.key} className={`flex items-center p-2 border rounded cursor-pointer transition-colors ${form.permissions[perm.key] ? 'bg-red-50 border-red-200' : 'hover:bg-gray-50'}`}>
                                        <input
                                            type="checkbox"
                                            className="w-4 h-4 text-red-600 rounded"
                                            checked={!!form.permissions[perm.key]}
                                            onChange={() => togglePerm(perm.key)}
                                        />
                                        <span className={`ml-2 text-xs font-medium ${form.permissions[perm.key] ? 'text-red-700' : 'text-gray-600'}`}>
                                            {perm.label}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex gap-2">
                    <button onClick={handleSave} className="flex-1 bg-green-600 text-white py-2 rounded">Salvar</button>
                    <button onClick={() => setEditing(null)} className="flex-1 bg-gray-200 text-gray-800 py-2 rounded">Cancelar</button>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 flex items-center text-gray-800"><Shield className="mr-2 text-blue-600" /> Perfis de Acesso</h2>
            <button onClick={() => { setEditing('new'); setForm({ name: '', permissions: {} }); }} className="mb-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center"><PlusCircle className="w-4 h-4 mr-2" /> Novo Perfil</button>
            <div className="grid gap-3">
                {profiles.map(p => (
                    <div key={p.id || p._id} className="bg-white p-4 rounded-lg shadow-sm border flex justify-between items-center">
                        <div><p className="font-bold text-gray-800">{p.name}</p><p className="text-xs text-gray-500 mt-1">{Object.keys(p.permissions || {}).filter(k => p.permissions[k]).length} permissões</p></div>
                        <div className="flex gap-2">
                            <button onClick={() => { setEditing(p.id || p._id); setForm({ name: p.name, permissions: p.permissions || {} }); }} className="text-blue-600 p-2 hover:bg-blue-50 rounded"><Edit2 className="w-4 h-4" /></button>
                            <button onClick={async () => { if (window.confirm('Excluir?')) { await api.delete(`/profiles/${p.id || p._id}`); load(); } }} className="text-red-600 p-2 hover:bg-red-50 rounded"><Trash2 className="w-4 h-4" /></button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const SchedulesPanel = () => {
    const [schedules, setSchedules] = useState([]);
    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState({ name: '', days: {} });

    useEffect(() => { load(); }, []);
    const load = async () => { try { const res = await api.get('/work-schedules'); setSchedules(res.data || []); } catch (e) { } };

    const handleSave = async () => {
        try {
            if (editing === 'new') await api.post('/work-schedules', form);
            else await api.put(`/work-schedules/${editing}`, form);
            setEditing(null); load();
        } catch (e) { alert("Erro ao salvar horário"); }
    };

    const updateSlot = (dayId, idx, field, val) => {
        const slots = [...(form.days[dayId] || [])];
        if (!slots[idx]) slots[idx] = { start: '08:00', end: '18:00' };
        slots[idx][field] = val;
        setForm({ ...form, days: { ...form.days, [dayId]: slots } });
    };

    const addSlot = (dayId) => {
        const slots = [...(form.days[dayId] || []), { start: '08:00', end: '18:00' }];
        setForm({ ...form, days: { ...form.days, [dayId]: slots } });
    };

    const removeSlot = (dayId, idx) => {
        const slots = [...(form.days[dayId] || [])];
        slots.splice(idx, 1);
        setForm({ ...form, days: { ...form.days, [dayId]: slots } });
    };

    if (editing) {
        return (
            <div className="bg-white p-6 rounded-lg shadow border max-w-4xl mx-auto">
                <div className="mb-6"><input type="text" placeholder="Nome da Escala" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full p-2 border rounded" /></div>
                <div className="space-y-4">
                    {DIAS_SEMANA.map(day => (
                        <div key={day.id} className="flex flex-col md:flex-row border rounded p-3 bg-gray-50">
                            <div className="w-32 font-bold text-gray-700 pt-2 flex items-center">{day.label}</div>
                            <div className="flex-1">
                                <div className="flex flex-wrap gap-2 mb-2">
                                    {(form.days[day.id] || []).map((slot, idx) => (
                                        <div key={idx} className="flex items-center bg-white border p-1 rounded shadow-sm">
                                            <input type="time" value={slot.start} onChange={e => updateSlot(day.id, idx, 'start', e.target.value)} className="bg-transparent text-sm" />
                                            <span className="mx-1 text-gray-400 text-xs">até</span>
                                            <input type="time" value={slot.end} onChange={e => updateSlot(day.id, idx, 'end', e.target.value)} className="bg-transparent text-sm" />
                                            <button onClick={() => removeSlot(day.id, idx)} className="ml-2 text-red-400"><X className="w-3 h-3" /></button>
                                        </div>
                                    ))}
                                </div>
                                <button onClick={() => addSlot(day.id)} className="text-xs font-bold text-blue-600">+ Adicionar Intervalo</button>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-6 flex gap-2">
                    <button onClick={handleSave} className="bg-green-600 text-white px-4 py-2 rounded">Salvar</button>
                    <button onClick={() => setEditing(null)} className="border px-4 py-2 rounded">Cancelar</button>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 flex items-center text-gray-800"><Clock className="mr-2 text-blue-600" /> Escalas e Horários</h2>
            <button onClick={() => { setEditing('new'); setForm({ name: '', days: {} }); }} className="mb-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center"><PlusCircle className="w-4 h-4 mr-2" /> Nova Escala</button>
            <div className="grid gap-3">
                {schedules.map(s => (
                    <div key={s.id || s._id} className="bg-white p-4 rounded-lg shadow-sm border flex justify-between items-center">
                        <span className="font-bold text-gray-800">{s.name}</span>
                        <div className="gap-2 flex">
                            <button onClick={() => { const days = {}; DIAS_SEMANA.forEach(d => { days[d.id] = s[d.id] || [] }); setEditing(s.id || s._id); setForm({ name: s.name, days }); }} className="text-blue-600 p-2"><Edit2 className="w-5 h-5" /></button>
                            <button onClick={async () => { if (window.confirm('Excluir?')) { await api.delete(`/work-schedules/${s.id || s._id}`); load(); } }} className="text-red-600 p-2"><Trash2 className="w-5 h-5" /></button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const CompaniesPanel = () => {
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [loadingData, setLoadingData] = useState(false);
    const [allServices, setAllServices] = useState([]);

    const emptyForm = {
        name: '', cnpj: '',
        ie: '', im: '', exterior: false,
        address: { cep: '', logradouro: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '' },
        phone: '', email: '', defaultIntegration: '', services: []
    };
    const [form, setForm] = useState(emptyForm);
    const [editing, setEditing] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingCnpj, setLoadingCnpj] = useState(false);
    const [companyTab, setCompanyTab] = useState('data'); // 'data' | 'clients'
    const [linkedClients, setLinkedClients] = useState([]);
    const [loadingClients, setLoadingClients] = useState(false);

    useEffect(() => {
        load();
        api.get('/services').then(r => setAllServices(r.data || [])).catch(() => {});
    }, [page, searchTerm]);

    const load = async () => {
        setLoadingData(true);
        try {
            const res = await api.get(`/external-companies?page=${page}&limit=20&search=${searchTerm}`);
            console.log('Companies API Response:', res.data); // 🆕"ç Debug
            if (res.data && Array.isArray(res.data.data)) {
                setList(res.data.data);
                setTotalPages(res.data.pages || 1);
            } else if (Array.isArray(res.data)) {
                // Fallback legado
                setList(res.data);
                setTotalPages(1);
            } else {
                setList([]);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchCnpj = async () => {
        const cnpj = form.cnpj.replace(/[^\dA-Za-z]/g, "");
        if (cnpj.length !== 14) return alert("CNPJ inválido (deve ter 14 dígitos)");

        setLoadingCnpj(true);
        try {
            // Usando Backend Proxy para obter IE e IM (via Focus NFe se disponível)
            const res = await api.get(`/utils/cnpj/${cnpj}`);
            const data = res.data;

            setForm(prev => ({
                ...prev,
                name: data.name || prev.name,
                ie: data.ie,
                im: data.im || '', // ç🆕 Preenche IM automaticamente se Focus achar
                address: {
                    cep: data.address.cep,
                    logradouro: data.address.logradouro,
                    numero: data.address.numero,
                    complemento: data.address.complemento,
                    bairro: data.address.bairro,
                    cidade: data.address.cidade,
                    uf: data.address.uf
                },
                phone: data.phone || prev.phone,
                email: data.email || prev.email
            }));
        } catch (error) {
            alert("Erro ao buscar CNPJ: " + (error.response?.data?.error || error.message));
        } finally {
            setLoadingCnpj(false);
        }
    };



    const save = async () => {
        if (!form.name) return alert("O nome da empresa é obrigatório");
        try {
            if (editing) {
                await api.put(`/external-companies/${editing}`, form);
                setEditing(null);
            } else {
                await api.post('/external-companies', form);
            }
            alert("Empresa salva com sucesso!");

            setForm(emptyForm);
            setIsModalOpen(false);
            load();
        } catch (error) {
            alert("Erro ao salvar empresa: " + (error.response?.data?.error || error.message));
        }
    };

    const handleEdit = (item) => {
        setEditing(item._id || item.id);
        // Compatibilidade com endereço legado (string) vs novo (objeto)
        let addr = { cep: '', logradouro: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '' };
        if (item.address && typeof item.address === 'object') {
            addr = item.address;
        } else if (typeof item.address === 'string') {
            addr.logradouro = item.address; // Fallback simples
        }

        setForm({
            name: item.name,
            cnpj: item.cnpj || '',
            ie: item.ie || '',
            im: item.im || '',
            exterior: item.exterior || false,
            address: addr,
            phone: item.phone || '',
            email: item.email || '',
            defaultIntegration: item.defaultIntegration || '',
            services: (item.services || []).map(s => String(s._id || s))
        });

        setCompanyTab('data');
        setLinkedClients([]);
        setIsModalOpen(true);
        
        // Carrega clientes vinculados em background
        const companyId = item._id || item.id;
        setLoadingClients(true);
        api.get(`/external-companies/${companyId}/clients`)
            .then(r => setLinkedClients(r.data || []))
            .catch(() => setLinkedClients([]))
            .finally(() => setLoadingClients(false));
    };

    const handleCancel = () => { setEditing(null); setForm(emptyForm); setIsModalOpen(false); setCompanyTab('data'); setLinkedClients([]); };

    const toggleService = (id) => {
        const sid = String(id);
        setForm(prev => ({
            ...prev,
            services: prev.services.includes(sid) ? prev.services.filter(x => x !== sid) : [...prev.services, sid]
        }));
    };

    const del = async (id) => {
        if (window.confirm("Excluir esta empresa?")) {
            await api.delete(`/external-companies/${id}`);
            load();
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                <h2 className="text-2xl font-bold flex items-center"><Building className="mr-2 text-blue-600" /> Empresas Externas</h2>
                
                <div className="flex gap-2 w-full md:w-auto">
                    <div className="relative flex-1 md:w-64">
                        <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Buscar empresa..."
                            className="w-full pl-10 pr-4 py-2 border rounded-lg"
                            value={searchTerm}
                            onChange={e => { setSearchTerm(e.target.value); setPage(1); }}
                        />
                    </div>
                    <button 
                        onClick={() => { setEditing(null); setForm(emptyForm); setIsModalOpen(true); }} 
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold hover:bg-blue-700 transition-colors flex items-center whitespace-nowrap"
                    >
                        <PlusCircle className="w-5 h-5 mr-2 hidden sm:block" /> Cadastrar Empresa
                    </button>
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={handleCancel}
                title={editing ? 'Editar Empresa' : 'Nova Empresa'}
                confirmText={companyTab === 'clients' ? null : (editing ? 'Salvar Alterações' : 'Cadastrar Empresa')}
                onConfirm={companyTab === 'clients' ? null : save}
                size="max-w-2xl"
            >
                {/* Abas - somente ao editar */}
                {editing && (
                    <div className="flex border-b border-gray-200 mb-4 -mx-0">
                        <button
                            onClick={() => setCompanyTab('data')}
                            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors ${
                                companyTab === 'data'
                                    ? 'border-blue-600 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                        >
                            <Building className="w-4 h-4" /> Dados da Empresa
                        </button>
                        <button
                            onClick={() => setCompanyTab('clients')}
                            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 transition-colors ${
                                companyTab === 'clients'
                                    ? 'border-blue-600 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700'
                            }`}
                        >
                            <Users className="w-4 h-4" />
                            Clientes Vinculados
                            {linkedClients.length > 0 && (
                                <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-0.5 rounded-full">
                                    {linkedClients.length}
                                </span>
                            )}
                        </button>
                    </div>
                )}

                {/* Aba: Dados da Empresa */}
                {companyTab === 'data' && (
                <div className="overflow-y-auto h-full pr-2 space-y-4 pb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">CNPJ (Opcional)</label>
                            <div className="flex gap-2">
                                <input
                                    value={form.cnpj}
                                    onChange={e => setForm({ ...form, cnpj: e.target.value })}
                                    className="flex-1 border p-2 rounded"
                                    placeholder="00.000.000/0000-00"
                                />
                                <button
                                    onClick={fetchCnpj}
                                    disabled={loadingCnpj}
                                    className="bg-blue-100 text-blue-700 px-3 rounded hover:bg-blue-200 transition-colors flex items-center"
                                    title="Buscar na Receita"
                                >
                                    {loadingCnpj ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
                                </button>
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">Nome/Razão Social <span className="text-red-500">*</span></label>
                            <input
                                value={form.name}
                                onChange={e => setForm({ ...form, name: e.target.value })}
                                className="w-full border p-2 rounded"
                                placeholder="Nome da Empresa"
                            />
                        </div>

                        {/* Campos Fiscais Extras */}
                        <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <label className="block text-xs font-bold text-gray-500 mb-1">Inscrição Estadual (IE)</label>
                                <input value={form.ie} onChange={e => setForm({ ...form, ie: e.target.value })} className="w-full border p-2 rounded" placeholder="Isento / IE" />
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-gray-500 mb-1">Inscrição Municipal (IM)</label>
                                <input value={form.im} onChange={e => setForm({ ...form, im: e.target.value })} className="w-full border p-2 rounded" placeholder="IM" />
                            </div>
                            <div className="flex items-center pt-5">
                                <label className="flex items-center space-x-2 cursor-pointer">
                                    <input type="checkbox" checked={form.exterior} onChange={e => setForm({ ...form, exterior: e.target.checked })} className="rounded text-blue-600 focus:ring-blue-500" />
                                    <span className="text-sm font-bold text-gray-700">Cliente no Exterior?</span>
                                </label>
                            </div>
                        </div>

                        <div className="md:col-span-2 border-t pt-4 mt-2">
                            <label className="block text-sm font-bold text-gray-700 mb-2">Endereço Completo</label>
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                                <div>
                                    <input value={form.address.cep} onChange={e => setForm({ ...form, address: { ...form.address, cep: e.target.value } })} className="w-full border p-2 rounded" placeholder="CEP" />
                                </div>
                                <div className="md:col-span-3">
                                    <input value={form.address.logradouro} onChange={e => setForm({ ...form, address: { ...form.address, logradouro: e.target.value } })} className="w-full border p-2 rounded" placeholder="Logradouro (Rua, Av...)" />
                                </div>
                                <div>
                                    <input value={form.address.numero} onChange={e => setForm({ ...form, address: { ...form.address, numero: e.target.value } })} className="w-full border p-2 rounded" placeholder="Número" />
                                </div>
                                <div>
                                    <input value={form.address.complemento} onChange={e => setForm({ ...form, address: { ...form.address, complemento: e.target.value } })} className="w-full border p-2 rounded" placeholder="Complemento" />
                                </div>
                                <div>
                                    <input value={form.address.bairro} onChange={e => setForm({ ...form, address: { ...form.address, bairro: e.target.value } })} className="w-full border p-2 rounded" placeholder="Bairro" />
                                </div>
                                <div>
                                    <input value={form.address.cidade} onChange={e => setForm({ ...form, address: { ...form.address, cidade: e.target.value } })} className="w-full border p-2 rounded" placeholder="Cidade" />
                                </div>
                                <div>
                                    <input value={form.address.uf} onChange={e => setForm({ ...form, address: { ...form.address, uf: e.target.value } })} className="w-full border p-2 rounded" placeholder="UF" maxLength={2} />
                                </div>
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">Telefone</label>
                            <input
                                value={form.phone}
                                onChange={e => setForm({ ...form, phone: e.target.value })}
                                className="w-full border p-2 rounded"
                                placeholder="(00) 0000-0000"
                            />
                        </div>

                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">Email</label>
                            <input
                                value={form.email}
                                onChange={e => setForm({ ...form, email: e.target.value })}
                                className="w-full border p-2 rounded"
                                placeholder="contato@empresa.com"
                            />
                        </div>
                    </div>

                    <div className="border-t pt-4">
                        <label className="block text-xs font-bold text-gray-500 mb-1">Integração Padrão (Para Boletos)</label>
                        <select
                            value={form.defaultIntegration}
                            onChange={e => setForm({ ...form, defaultIntegration: e.target.value })}
                            className="w-full border p-2 rounded"
                        >
                            <option value="">Selecione...</option>
                            <option value="cora">Banco Cora</option>
                            <option value="asaas">Asaas</option>
                            <option value="inter">Banco Inter</option>
                        </select>
                    </div>

                    {allServices.length > 0 && (
                        <div className="border-t pt-4">
                            <label className="block text-sm font-bold text-gray-700 mb-2 flex items-center gap-2">
                                <Briefcase className="w-4 h-4 text-blue-600" /> Serviços Contratados
                            </label>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 bg-gray-50 border border-gray-200 rounded-lg p-3">
                                {allServices.map(s => {
                                    const sid = String(s._id || s.id);
                                    const checked = (form.services || []).includes(sid);
                                    return (
                                        <label key={sid} className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer border transition-all select-none ${
                                            checked ? 'bg-blue-50 border-blue-400 text-blue-800 font-semibold' : 'bg-white border-gray-200 text-gray-700 hover:border-blue-300'
                                        }`}>
                                            <input type="checkbox" className="sr-only" checked={checked} onChange={() => toggleService(sid)} />
                                            <div className={`w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 ${checked ? 'bg-blue-600 border-blue-600' : 'border-gray-300'}`}>
                                                {checked && <CheckCircle className="w-3 h-3 text-white" />}
                                            </div>
                                            <span className="text-xs leading-tight">{s.name}</span>
                                        </label>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
                )}

                {/* Aba: Clientes Vinculados */}
                {companyTab === 'clients' && (
                    <div className="py-2">
                        {loadingClients ? (
                            <div className="flex justify-center py-12">
                                <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
                            </div>
                        ) : linkedClients.length === 0 ? (
                            <div className="text-center py-12">
                                <Users className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                                <p className="text-gray-500 font-medium">Nenhum cliente vinculado</p>
                                <p className="text-gray-400 text-sm mt-1">Clientes com o campo "Empresa" igual a <strong>{form.name}</strong> aparecerão aqui.</p>
                            </div>
                        ) : (
                            <div>
                                <p className="text-xs text-gray-500 mb-3">
                                    {linkedClients.length} cliente(s) com empresa <strong>{form.name}</strong>
                                </p>
                                <div className="divide-y divide-gray-100 border border-gray-200 rounded-lg overflow-hidden max-h-[50vh] overflow-y-auto">
                                    {linkedClients.map(c => (
                                        <div key={c._id} className="flex items-center gap-3 p-3 hover:bg-gray-50 transition-colors">
                                            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center shrink-0 shadow-sm overflow-hidden">
                                                {c.profilePicUrl ? (
                                                    <img src={c.profilePicUrl} alt="" className="w-full h-full object-cover" />
                                                ) : (
                                                    <span className="text-white font-bold text-sm">{(c.name || c.phone || '?').charAt(0).toUpperCase()}</span>
                                                )}
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <p className="font-semibold text-gray-800 text-sm truncate">{c.name || 'Sem nome'}</p>
                                                <p className="text-xs text-gray-500">{c.phone}</p>
                                            </div>
                                            {c.isBlocked && (
                                                <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full font-medium">Bloqueado</span>
                                            )}
                                            <span className="text-xs text-gray-400 shrink-0">
                                                {new Date(c.createdAt).toLocaleDateString('pt-BR')}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Modal>

            {loadingData && <div className="text-center py-4"><Loader2 className="w-6 h-6 animate-spin mx-auto text-blue-600" /></div>}

            <div className="bg-white rounded shadow border divide-y">
                {list.length === 0 && <div className="p-8 text-center text-gray-400">Nenhuma empresa cadastrada.</div>}
                {list.map(i => (
                    <div key={i._id || i.id} className="p-4 flex flex-col md:flex-row justify-between items-start md:items-center hover:bg-gray-50 transition-colors gap-4">
                        <div>
                            <span className="font-bold text-gray-800 text-lg">{i.name}</span>
                            {(i.cnpj || i.email || i.phone) && (
                                <div className="text-sm text-gray-500 flex flex-wrap gap-x-4 gap-y-1 mt-1">
                                    {i.cnpj && <span className="flex items-center"><Hash className="w-3 h-3 mr-1" /> {i.cnpj}</span>}
                                    {i.phone && <span className="flex items-center"><Wifi className="w-3 h-3 mr-1" /> {i.phone}</span>}
                                    {i.email && <span className="flex items-center"><MessageSquare className="w-3 h-3 mr-1" /> {i.email}</span>}
                                </div>
                            )}
                            {i.address && (
                                <div className="text-xs text-gray-400 mt-1">
                                    {typeof i.address === 'object'
                                        ? `${i.address.logradouro}, ${i.address.numero} - ${i.address.cidade}/${i.address.uf}`
                                        : i.address}
                                </div>
                            )}
                            {/* Serviços vinculados ç empresa */}
                            {(i.services && i.services.length > 0) && (
                                <div className="flex flex-wrap gap-1.5 mt-2">
                                    {i.services.map(sid => {
                                        const svc = allServices.find(s => String(s._id || s.id) === String(sid._id || sid));
                                        if (!svc) return null;
                                        return (
                                            <span key={String(sid._id || sid)} className="inline-flex items-center gap-1 bg-blue-50 text-blue-700 border border-blue-200 text-xs font-semibold px-2 py-0.5 rounded-full">
                                                <Briefcase className="w-3 h-3" />{svc.name}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="flex gap-2 self-end md:self-auto">
                            <button onClick={() => handleEdit(i)} className="text-blue-600 p-2 hover:bg-blue-50 rounded" title="Editar"><Edit2 className="w-4 h-4" /></button>
                            <button onClick={() => del(i._id || i.id)} className="text-red-500 p-2 hover:bg-red-50 rounded" title="Excluir"><Trash2 className="w-4 h-4" /></button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="flex justify-between items-center mt-4">
                <span className="text-sm text-gray-500">Página {page} de {totalPages}</span>
                <div className="flex gap-2">
                    <button
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        disabled={page === 1}
                        className="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
                    >
                        Anterior
                    </button>
                    <button
                        onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                        disabled={page === totalPages}
                        className="px-3 py-1 border rounded hover:bg-gray-100 disabled:opacity-50"
                    >
                        Próxima
                    </button>
                </div>
            </div>
        </div>
    );
};

const IntegrationsPanel = () => {
    const [config, setConfig] = useState({
        cora: { clientId: '', clientSecret: '', isActive: false },
        asaas: { apiKey: '', walletId: '', isActive: false },
        inter: { clientId: '', clientSecret: '', cert: '', key: '', isActive: false },
        email: { host: '', port: 587, user: '', pass: '', fromName: '', secure: false, isActive: false, template: { subject: '', body: '' } },
        nfse: {
            cnpj: '', im: '', codMun: '', aliquota: 2,
            cnae: '', itemLc116: '', codigoNbs: '', issRetido: false, responsavelRetencao: 2, obraCode: '', art: '',
            production: false, isActive: false,
            models: [] // ç🆕
        }
    });
    const [activeTab, setActiveTab] = useState('cora');
    const [loading, setLoading] = useState(false);

    useEffect(() => { load(); }, []);

    const load = async () => {
        try {
            const res = await api.get('/integrations');
            if (res.data) {
                setConfig({
                    cora: { clientId: '', clientSecret: '', isActive: false, ...(res.data.cora || {}) },
                    asaas: { apiKey: '', walletId: '', isActive: false, ...(res.data.asaas || {}) },
                    inter: { clientId: '', clientSecret: '', cert: '', key: '', isActive: false, ...(res.data.inter || {}) },
                    email: { host: '', port: 587, user: '', pass: '', fromName: '', secure: false, isActive: false, ...(res.data.email || {}) },
                    nfse: {
                        cnpj: '', im: '', codMun: '', aliquota: 2,
                        cnae: '', itemLc116: '', codigoNbs: '', issRetido: false, responsavelRetencao: 2, obraCode: '', art: '',
                        production: false, isActive: false,
                        models: [], // ç🆕
                        ...(res.data.nfse || {})
                    }
                });
            }
        } catch (e) {
            console.error("Erro ao carregar integrações", e);
        }
    };

    const handleChange = (bank, field, value) => {
        setConfig(prev => ({
            ...prev,
            [bank]: { ...prev[bank], [field]: value }
        }));
    };

    const toggleActive = (bank) => {
        setConfig(prev => ({
            ...prev,
            [bank]: { ...prev[bank], isActive: !prev[bank].isActive }
        }));
    };

    const handleFileImport = (e, bank, field) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            handleChange(bank, field, event.target.result);
        };
        reader.readAsText(file);
        e.target.value = null; // Reset input
    };

    const addNfseModel = () => {
        const modelName = prompt("Nome para este modelo (ex: 'Desenvolvimento de Software')");
        if (!modelName) return;

        setConfig(prev => {
            const currentNfse = prev.nfse;
            const newModel = {
                name: modelName,
                cnpj: currentNfse.cnpj,
                im: currentNfse.im,
                codMun: currentNfse.codMun,
                aliquota: currentNfse.aliquota,
                cnae: currentNfse.cnae,
                itemLc116: currentNfse.itemLc116,
                codigoNbs: currentNfse.codigoNbs,
                issRetido: currentNfse.issRetido,
                responsavelRetencao: currentNfse.responsavelRetencao,
                obraCode: currentNfse.obraCode,
                art: currentNfse.art,
                naturezaOperacao: currentNfse.naturezaOperacao, // ç🆕
                municipioIncidencia: currentNfse.municipioIncidencia, // ç🆕
                estadoIncidencia: currentNfse.estadoIncidencia, // ç🆕
            };
            return {
                ...prev,
                nfse: {
                    ...currentNfse,
                    models: [...(currentNfse.models || []), newModel]
                }
            };
        });
    };

    const loadNfseModel = (model) => {
        setConfig(prev => ({
            ...prev,
            nfse: {
                ...prev.nfse,
                cnpj: model.cnpj,
                im: model.im,
                codMun: model.codMun,
                aliquota: model.aliquota,
                cnae: model.cnae,
                itemLc116: model.itemLc116,
                codigoNbs: model.codigoNbs,
                issRetido: model.issRetido,
                responsavelRetencao: model.responsavelRetencao,
                obraCode: model.obraCode,
                art: model.art,
                naturezaOperacao: model.naturezaOperacao, // ç🆕
                municipioIncidencia: model.municipioIncidencia, // ç🆕
                estadoIncidencia: model.estadoIncidencia, // ç🆕
            }
        }));
    };

    const removeNfseModel = (index) => {
        if (!window.confirm("Tem certeza que deseja remover este modelo?")) return;
        setConfig(prev => ({
            ...prev,
            nfse: {
                ...prev.nfse,
                models: prev.nfse.models.filter((_, i) => i !== index)
            }
        }));
    };

    const save = async () => {
        setLoading(true);
        try {
            await api.put('/integrations', config);
            alert("Configurações salvas com sucesso!");
        } catch (e) {
            alert("Erro ao salvar configurações.");
        } finally {
            setLoading(false);
        }
    };

    const setAsDefaultAll = async (integrationId) => {
        if (!window.confirm(`Tem certeza? Isso definirá a integração ${integrationId.toUpperCase()} como padrão para TODAS as empresas cadastradas.`)) return;

        setLoading(true);
        try {
            await api.post('/integrations/set-default-all', { integrationId });
            alert(`Sucesso! Agora todas as empresas usarão ${integrationId.toUpperCase()} como padrão.`);
        } catch (e) {
            alert("Erro ao atualizar empresas.");
        } finally {
            setLoading(false);
        }
    };

    const tabs = [
        { id: 'cora', label: 'Banco Cora' },
        { id: 'asaas', label: 'Asaas' },
        { id: 'inter', label: 'Banco Inter' },
        { id: 'email', label: 'E-mail (SMTP)' },
        { id: 'nfse', label: 'NFS-e (Fiscal)' }
    ];

    return (
        <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 flex items-center text-gray-800">
                <Link2 className="mr-2 text-blue-600" /> Integrações
            </h2>

            <div className="bg-white rounded-lg shadow border overflow-hidden">
                {/* Abas */}
                <div className="flex border-b">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex-1 py-4 text-sm font-medium text-center transition-colors ${activeTab === tab.id
                                ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600'
                                : 'text-gray-500 hover:bg-gray-50'
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* Conteúdo */}
                <div className="p-6">
                    {activeTab === 'cora' && (
                        <div className="space-y-4 animate-fadeIn">
                            <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg border mb-4">
                                <span className={`font-bold ${config.cora.isActive ? 'text-green-600' : 'text-gray-500'}`}>
                                    {config.cora.isActive ? 'Integração Ativa' : 'Integração Inativa'}
                                </span>
                                <button
                                    onClick={() => toggleActive('cora')}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${config.cora.isActive ? 'bg-green-500' : 'bg-gray-300'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${config.cora.isActive ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            <div className={config.cora.isActive ? '' : 'opacity-50 pointer-events-none'}>
                                <div className="flex justify-end mb-4">
                                    <button onClick={() => setAsDefaultAll('cora')} className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded hover:bg-blue-200 transition-colors font-bold">
                                        Definir como Padrão para TODOS os Clientes
                                    </button>
                                </div>
                                <h3 className="font-bold text-gray-700 mb-2">Credenciais Cora</h3>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">Client ID</label>
                                    <input
                                        type="text"
                                        value={config.cora.clientId}
                                        onChange={e => handleChange('cora', 'clientId', e.target.value)}
                                        className="w-full p-2 border rounded font-mono text-sm"
                                        placeholder="Cole o Client ID aqui"
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">Client Secret</label>
                                    <input
                                        type="password"
                                        value={config.cora.clientSecret}
                                        onChange={e => handleChange('cora', 'clientSecret', e.target.value)}
                                        className="w-full p-2 border rounded font-mono text-sm"
                                        placeholder="Cole o Client Secret aqui"
                                    />
                                </div>
                                <div className="bg-blue-50 p-3 rounded text-xs text-blue-700">
                                    Para obter essas credenciais, acesse o painel de desenvolvedor do Banco Cora.
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'asaas' && (
                        <div className="space-y-4 animate-fadeIn">
                            <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg border mb-4">
                                <span className={`font-bold ${config.asaas.isActive ? 'text-green-600' : 'text-gray-500'}`}>
                                    {config.asaas.isActive ? 'Integração Ativa' : 'Integração Inativa'}
                                </span>
                                <button
                                    onClick={() => toggleActive('asaas')}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${config.asaas.isActive ? 'bg-green-500' : 'bg-gray-300'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${config.asaas.isActive ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            <div className={config.asaas.isActive ? '' : 'opacity-50 pointer-events-none'}>
                                <div className="flex justify-end mb-4">
                                    <button onClick={() => setAsDefaultAll('asaas')} className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded hover:bg-blue-200 transition-colors font-bold">
                                        Definir como Padrão para TODOS os Clientes
                                    </button>
                                </div>
                                <h3 className="font-bold text-gray-700 mb-2">Credenciais Asaas</h3>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">API Key</label>
                                    <input
                                        type="password"
                                        value={config.asaas.apiKey}
                                        onChange={e => handleChange('asaas', 'apiKey', e.target.value)}
                                        className="w-full p-2 border rounded font-mono text-sm"
                                        placeholder="$aact_..."
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">Wallet ID (Opcional)</label>
                                    <input
                                        type="text"
                                        value={config.asaas.walletId}
                                        onChange={e => handleChange('asaas', 'walletId', e.target.value)}
                                        className="w-full p-2 border rounded font-mono text-sm"
                                        placeholder="Identificador da carteira (se houver multiplas)"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'inter' && (
                        <div className="space-y-4 animate-fadeIn">
                            <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg border mb-4">
                                <span className={`font-bold ${config.inter.isActive ? 'text-green-600' : 'text-gray-500'}`}>
                                    {config.inter.isActive ? 'Integração Ativa' : 'Integração Inativa'}
                                </span>
                                <button
                                    onClick={() => toggleActive('inter')}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${config.inter.isActive ? 'bg-green-500' : 'bg-gray-300'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${config.inter.isActive ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            <div className={config.inter.isActive ? '' : 'opacity-50 pointer-events-none'}>
                                <div className="flex justify-end mb-4">
                                    <button onClick={() => setAsDefaultAll('inter')} className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded hover:bg-blue-200 transition-colors font-bold">
                                        Definir como Padrão para TODOS os Clientes
                                    </button>
                                </div>
                                <h3 className="font-bold text-gray-700 mb-2">Credenciais Banco Inter</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Client ID</label>
                                        <input
                                            type="text"
                                            value={config.inter.clientId}
                                            onChange={e => handleChange('inter', 'clientId', e.target.value)}
                                            className="w-full p-2 border rounded font-mono text-sm"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Client Secret</label>
                                        <input
                                            type="password"
                                            value={config.inter.clientSecret}
                                            onChange={e => handleChange('inter', 'clientSecret', e.target.value)}
                                            className="w-full p-2 border rounded font-mono text-sm"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">Certificado (.crt / .pem)</label>
                                    <textarea
                                        value={config.inter.cert}
                                        onChange={e => handleChange('inter', 'cert', e.target.value)}
                                        className="w-full p-2 border rounded font-mono text-xs h-24"
                                        placeholder="-----BEGIN CERTIFICATE-----..."
                                    />
                                </div>

                                <div>
                                    <label className="block text-xs font-bold text-gray-500 mb-1">Chave Privada (.key)</label>
                                    <textarea
                                        value={config.inter.key}
                                        onChange={e => handleChange('inter', 'key', e.target.value)}
                                        className="w-full p-2 border rounded font-mono text-xs h-24"
                                        placeholder="-----BEGIN PRIVATE KEY-----..."
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'email' && (
                        <div className="space-y-4 animate-fadeIn">
                            <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg border mb-4">
                                <span className={`font-bold ${config.email.isActive ? 'text-green-600' : 'text-gray-500'}`}>
                                    {config.email.isActive ? 'Envio de Email Ativo' : 'Envio de Email Inativo'}
                                </span>
                                <button onClick={() => toggleActive('email')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${config.email.isActive ? 'bg-green-500' : 'bg-gray-300'}`}>
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${config.email.isActive ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            <div className={config.email.isActive ? '' : 'opacity-50 pointer-events-none'}>
                                <h3 className="font-bold text-gray-700 mb-2">Configurações SMTP</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Host SMTP</label>
                                        <input className="w-full border p-2 rounded" placeholder="smtp.gmail.com" value={config.email.host || ''} onChange={e => handleChange('email', 'host', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Porta</label>
                                        <input type="number" className="w-full border p-2 rounded" placeholder="587" value={config.email.port || ''} onChange={e => handleChange('email', 'port', parseInt(e.target.value))} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Email / Usuário</label>
                                        <input className="w-full border p-2 rounded" placeholder="seu@email.com" value={config.email.user || ''} onChange={e => handleChange('email', 'user', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Senha</label>
                                        <input type="password" className="w-full border p-2 rounded" placeholder="Senha do email" value={config.email.pass || ''} onChange={e => handleChange('email', 'pass', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Nome Remetente</label>
                                        <input className="w-full border p-2 rounded" placeholder="Financeiro" value={config.email.fromName || ''} onChange={e => handleChange('email', 'fromName', e.target.value)} />
                                    </div>
                                    <div className="flex items-end mb-2">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input type="checkbox" checked={config.email.secure || false} onChange={e => handleChange('email', 'secure', e.target.checked)} className="rounded text-blue-600 focus:ring-blue-500" />
                                            <span className="text-sm text-gray-700">Usar SSL (Porta 465)</span>
                                        </label>
                                    </div>

                                    <div className="md:col-span-2 pt-4 border-t">
                                        <h4 className="font-bold text-gray-700 mb-2">Modelo de Email Padrão</h4>
                                        <div className="grid gap-3">
                                            <div>
                                                <label className="block text-xs font-bold text-gray-500 mb-1">Assunto</label>
                                                <input className="w-full border p-2 rounded" placeholder="Nova Fatura Disponível" value={config.email.template?.subject || ''} onChange={e => handleChange('email', 'template', { ...config.email.template, subject: e.target.value })} />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-bold text-gray-500 mb-1">Corpo da Mensagem</label>
                                                <textarea rows="4" className="w-full border p-2 rounded" placeholder="Olá {cliente}, segue sua fatura de R$ {valor}..." value={config.email.template?.body || ''} onChange={e => handleChange('email', 'template', { ...config.email.template, body: e.target.value })} />
                                                <p className="text-xs text-gray-400 mt-1">Variáveis disponíveis: {'{cliente}, {valor}, {vencimento}'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}



                    {activeTab === 'nfse' && (
                        <div className="space-y-4 animate-fadeIn">
                            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
                                <p className="text-sm text-blue-700">
                                    Configure os dados fiscais da sua empresa para emissão de notas.
                                    A comunicação com a prefeitura é gerenciada pelo sistema.
                                </p>
                            </div>

                            <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg border mb-4">
                                <span className={`font-bold ${config.nfse.isActive ? 'text-green-600' : 'text-gray-500'}`}>
                                    {config.nfse.isActive ? 'Emissão Fiscal Ativa' : 'Emissão Fiscal Inativa'}
                                </span>
                                <button onClick={() => toggleActive('nfse')} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${config.nfse.isActive ? 'bg-green-500' : 'bg-gray-300'}`}>
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${config.nfse.isActive ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            <div className={config.nfse.isActive ? '' : 'opacity-50 pointer-events-none'}>
                                <h3 className="font-bold text-gray-700 mb-2">Dados do Prestador (Sua Empresa)</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">CNPJ</label>
                                        <input className="w-full border p-2 rounded" placeholder="00.000.000/0000-00" value={config.nfse.cnpj || ''} onChange={e => handleChange('nfse', 'cnpj', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Inscrição Municipal (IM)</label>
                                        <input className="w-full border p-2 rounded" placeholder="123456" value={config.nfse.im || ''} onChange={e => handleChange('nfse', 'im', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Cód. Município (IBGE)</label>
                                        <input className="w-full border p-2 rounded" placeholder="3550308 (Ex: SP)" value={config.nfse.codMun || ''} onChange={e => handleChange('nfse', 'codMun', e.target.value)} />
                                        <a href="https://www.ibge.gov.br/explica/codigos-dos-municipios.php" target="_blank" rel="noreferrer" className="text-xs text-blue-500 hover:underline">Consultar Código</a>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Alíquota ISS (%)</label>
                                        <input type="number" step="0.01" className="w-full border p-2 rounded" placeholder="2.00" value={config.nfse.aliquota || ''} onChange={e => handleChange('nfse', 'aliquota', parseFloat(e.target.value))} />
                                    </div>
                                </div>
                                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-4 mt-2">
                                    <div className="md:col-span-3 font-bold text-gray-700">Dados do Serviço (Padrão)</div>

                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">CNAE</label>
                                        <input className="w-full border p-2 rounded" placeholder="Ex: 6209100" value={config.nfse.cnae || ''} onChange={e => handleChange('nfse', 'cnae', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Item LC 116/2003</label>
                                        <input className="w-full border p-2 rounded" placeholder="Ex: 01.07" value={config.nfse.itemLc116 || ''} onChange={e => handleChange('nfse', 'itemLc116', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Código NBS</label>
                                        <input className="w-full border p-2 rounded" placeholder="Ex: 1.01..." value={config.nfse.codigoNbs || ''} onChange={e => handleChange('nfse', 'codigoNbs', e.target.value)} />
                                    </div>

                                    <div className="flex items-center space-x-4">
                                        <label className="flex items-center space-x-2 cursor-pointer">
                                            <input type="checkbox" checked={config.nfse.issRetido || false} onChange={e => handleChange('nfse', 'issRetido', e.target.checked)} className="rounded text-blue-600 focus:ring-blue-500" />
                                            <span className="text-sm text-gray-700">ISS Retido</span>
                                        </label>
                                    </div>
                                    <div className="md:col-span-2">
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Responsável Retenção</label>
                                        <select className="w-full border p-2 rounded bg-white" value={config.nfse.responsavelRetencao || 2} onChange={e => handleChange('nfse', 'responsavelRetencao', parseInt(e.target.value))}>
                                            <option value={1}>1 - Tomador</option>
                                            <option value={2}>2 - Prestador</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">Cód. Obra (Opcional)</label>
                                        <input className="w-full border p-2 rounded" placeholder="" value={config.nfse.obraCode || ''} onChange={e => handleChange('nfse', 'obraCode', e.target.value)} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 mb-1">ART (Opcional)</label>
                                        <input className="w-full border p-2 rounded" placeholder="" value={config.nfse.art || ''} onChange={e => handleChange('nfse', 'art', e.target.value)} />
                                    </div>

                                    <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-4 mt-2">
                                        <div className="md:col-span-3 font-bold text-gray-700 text-xs uppercase">Incidência e Natureza</div>
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 mb-1">Natureza da Operação</label>
                                            <select className="w-full border p-2 rounded bg-white" value={config.nfse.naturezaOperacao || '1'} onChange={e => handleChange('nfse', 'naturezaOperacao', e.target.value)}>
                                                <option value="1">1 - Tributação no município</option>
                                                <option value="2">2 - Tributação fora do município</option>
                                                <option value="3">3 - Isenção</option>
                                                <option value="4">4 - Imune</option>
                                                <option value="5">5 - Exigibilidade Suspensa</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 mb-1">Município Incidência</label>
                                            <input className="w-full border p-2 rounded" placeholder="Ex: São Paulo" value={config.nfse.municipioIncidencia || ''} onChange={e => handleChange('nfse', 'municipioIncidencia', e.target.value)} />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 mb-1">UF Incidência</label>
                                            <input className="w-full border p-2 rounded" placeholder="Ex: SP" maxLength={2} value={config.nfse.estadoIncidencia || ''} onChange={e => handleChange('nfse', 'estadoIncidencia', e.target.value.toUpperCase())} />
                                        </div>
                                    </div>
                                </div>

                                {/* Gerenciamento de Modelos */}
                                <div className="mt-4 pt-4 border-t">
                                    <div className="flex justify-between items-center mb-2">
                                        <h4 className="font-bold text-gray-700">Modelos Salvos</h4>
                                        <button onClick={addNfseModel} className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded hover:bg-blue-200 font-bold">
                                            + Salvar Atuais como Modelo
                                        </button>
                                    </div>
                                    {(!config.nfse.models || config.nfse.models.length === 0) && <p className="text-xs text-gray-400 italic">Nenhum modelo salvo.</p>}
                                    <div className="space-y-2">
                                        {config.nfse.models?.map((model, idx) => (
                                            <div key={idx} className="flex justify-between items-center bg-gray-100 p-2 rounded">
                                                <div>
                                                    <span className="font-bold text-sm text-gray-700">{model.name}</span>
                                                    <p className="text-xs text-gray-500">{model.itemLc116} - {model.cnae}</p>
                                                </div>
                                                <div className="flex gap-2">
                                                    <button onClick={() => loadNfseModel(model)} className="text-blue-500 hover:text-blue-700 text-xs font-bold" title="Carregar nestes campos">Carregar</button>
                                                    <button onClick={() => removeNfseModel(idx)} className="text-red-500 hover:text-red-700 text-xs font-bold" title="Excluir">X</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="flex items-end mb-2 pt-4 border-t w-full">
                                    <label className="flex items-center space-x-2 cursor-pointer">
                                        <input type="checkbox" checked={config.nfse.production || false} onChange={e => handleChange('nfse', 'production', e.target.checked)} className="rounded text-blue-600 focus:ring-blue-500" />
                                        <span className="text-sm text-gray-700 font-bold">Ambiente de Produção (Valendo!)</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mt-8 pt-4 border-t flex justify-end">
                        <button
                            onClick={save}
                            disabled={loading}
                            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-bold flex items-center shadow-sm disabled:opacity-50"
                        >
                            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}
                            Salvar Configurações
                        </button>
                    </div>
                </div>
            </div>

        </div>
    );
};

// ==================================================================================
// ç🆕 CATEGORIAS DE ATENDIMENTO
// ==================================================================================
const CategoriesPanel = () => {
    const [categories, setCategories] = useState([]);
    const [required, setRequired] = useState(false);
    const [newCatName, setNewCatName] = useState('');
    const [expanded, setExpanded] = useState({});
    const [newSubNames, setNewSubNames] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => { load(); }, []);

    const load = async () => {
        setLoading(true);
        try {
            const [catRes, settRes] = await Promise.all([
                api.get('/categories'),
                api.get('/settings/categories')
            ]);
            setCategories(catRes.data || []);
            setRequired(settRes.data?.categorizationRequired || false);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    };

    const toggleRequired = async (val) => {
        setRequired(val);
        try { await api.put('/settings/categories', { categorizationRequired: val }); }
        catch (e) { setRequired(!val); alert('Erro ao salvar.'); }
    };

    const addCategory = async () => {
        if (!newCatName.trim()) return;
        try {
            await api.post('/categories', { name: newCatName.trim() });
            setNewCatName('');
            load();
        } catch (e) { alert('Erro ao criar categoria.'); }
    };

    const deleteCategory = async (id) => {
        if (!window.confirm('Remover esta categoria e todas as suas subcategorias?')) return;
        try { await api.delete(`/categories/${id}`); load(); }
        catch (e) { alert('Erro ao remover categoria.'); }
    };

    const addSubcategory = async (cat) => {
        const subName = newSubNames[cat._id]?.trim();
        if (!subName) return;
        const updatedSubs = [...(cat.subcategories || []), { name: subName }];
        try {
            await api.put(`/categories/${cat._id}`, { subcategories: updatedSubs });
            setNewSubNames(prev => ({ ...prev, [cat._id]: '' }));
            load();
        } catch (e) { alert('Erro ao adicionar subcategoria.'); }
    };

    const deleteSubcategory = async (cat, subIdx) => {
        const updatedSubs = cat.subcategories.filter((_, i) => i !== subIdx);
        try { await api.put(`/categories/${cat._id}`, { subcategories: updatedSubs }); load(); }
        catch (e) { alert('Erro ao remover subcategoria.'); }
    };

    const toggleExpand = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

    return (
        <div className="max-w-2xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800 flex items-center"><Tag className="mr-2 text-blue-600" /> Categorias de Atendimento</h2>
            </div>

            {/* TOGGLE DE OBRIGATORIEDADE */}
            <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-200 flex justify-between items-center mb-6">
                <div>
                    <h3 className="font-bold text-blue-800">Categorização Obrigatória</h3>
                    <p className="text-sm text-blue-700">Se ativo, o atendente será obrigado a categorizar ao Finalizar ou Cancelar um atendimento.</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" checked={required} onChange={e => toggleRequired(e.target.checked)} />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-blue-600 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
            </div>

            {/* ADICIONAR NOVA CATEGORIA */}
            <div className="flex gap-2 mb-4">
                <input
                    value={newCatName}
                    onChange={e => setNewCatName(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && addCategory()}
                    className="flex-1 border p-2 rounded"
                    placeholder="Nome da categoria (ex: Suporte Técnico)"
                />
                <button onClick={addCategory} className="bg-blue-600 text-white px-4 rounded font-bold hover:bg-blue-700 flex items-center"><PlusCircle className="w-4 h-4 mr-1" /> Adicionar</button>
            </div>

            {/* LISTA DE CATEGORIAS */}
            {loading ? (
                <div className="text-center py-8 text-gray-400"><Loader2 className="w-6 h-6 animate-spin mx-auto mb-2" />Carregando...</div>
            ) : categories.length === 0 ? (
                <div className="text-center py-12 text-gray-400 border-2 border-dashed rounded-lg">
                    <Tag className="w-12 h-12 mx-auto mb-3 opacity-30" />
                    <p className="font-medium">Nenhuma categoria cadastrada</p>
                    <p className="text-sm">Adicione categorias para organizar os atendimentos</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {categories.map(cat => (
                        <div key={cat._id} className="bg-white border rounded-lg shadow-sm overflow-hidden">
                            {/* HEADER DA CATEGORIA */}
                            <div className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 select-none" onClick={() => toggleExpand(cat._id)}>
                                <div className="flex items-center gap-2">
                                    {expanded[cat._id] ? <ChevronDown className="w-4 h-4 text-gray-400" /> : <ChevronRight className="w-4 h-4 text-gray-400" />}
                                    <span className="font-bold text-gray-800">{cat.name}</span>
                                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{cat.subcategories?.length || 0} subcategorias</span>
                                </div>
                                <button onClick={e => { e.stopPropagation(); deleteCategory(cat._id); }} className="text-red-500 hover:bg-red-50 p-1.5 rounded">
                                    <Trash2 className="w-4 h-4" />
                                </button>
                            </div>

                            {/* SUBCATEGORIAS (EXPANSÍVEL) */}
                            {expanded[cat._id] && (
                                <div className="border-t bg-gray-50 p-4 space-y-2">
                                    {(cat.subcategories || []).map((sub, idx) => (
                                        <div key={idx} className="flex items-center justify-between bg-white border rounded px-3 py-2">
                                            <span className="text-sm text-gray-700">ç?ç {sub.name}</span>
                                            <button onClick={() => deleteSubcategory(cat, idx)} className="text-red-400 hover:text-red-600 p-1">
                                                <X className="w-3 h-3" />
                                            </button>
                                        </div>
                                    ))}
                                    {/* Adicionar subcategoria */}
                                    <div className="flex gap-2 mt-2">
                                        <input
                                            value={newSubNames[cat._id] || ''}
                                            onChange={e => setNewSubNames(prev => ({ ...prev, [cat._id]: e.target.value }))}
                                            onKeyDown={e => e.key === 'Enter' && addSubcategory(cat)}
                                            className="flex-1 border p-1.5 rounded text-sm"
                                            placeholder="Nova subcategoria..."
                                        />
                                        <button onClick={() => addSubcategory(cat)} className="bg-green-600 text-white px-3 py-1.5 rounded text-sm font-bold hover:bg-green-700">
                                            <PlusCircle className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const QuickMessagesPanel = () => {
    const [list, setList] = useState([]);
    const [form, setForm] = useState({ title: '', text: '' });
    useEffect(() => { load(); }, []);
    const load = async () => { const res = await api.get('/quick-messages'); setList(res.data || []); };
    const add = async () => { if (form.title) { await api.post('/quick-messages', form); setForm({ title: '', text: '' }); load(); } };
    const del = async (id) => { await api.delete(`/quick-messages/${id}`); load(); };
    return (
        <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold mb-4 flex items-center"><Zap className="mr-2 text-yellow-500" /> Mensagens Rápidas</h2>
            <div className="bg-gray-100 p-4 rounded mb-4 grid gap-3">
                <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} className="border p-2 rounded" placeholder="Atalho (ex: /pix)" />
                <textarea value={form.text} onChange={e => setForm({ ...form, text: e.target.value })} className="border p-2 rounded" placeholder="Texto" />
                <button onClick={add} className="bg-blue-600 text-white py-2 rounded font-bold">Salvar Atalho</button>
            </div>
            <div className="space-y-2">{list.map(i => <div key={i._id || i.id} className="p-4 border rounded bg-white shadow-sm flex justify-between"><div><strong className="text-blue-600 block">{i.title}</strong><span className="text-gray-600">{i.text}</span></div><button onClick={() => del(i._id || i.id)} className="text-red-500"><Trash2 className="w-4 h-4" /></button></div>)}</div>
        </div>
    );
};

const ConnectionPanel = ({ currentUser }) => {
    const [qr, setQr] = useState('');
    const [status, setStatus] = useState('DISCONNECTED');
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const loadInitialStatus = async () => {
            try {
                const res = await api.get('/whatsapp/status');
                setStatus(res.data.connectionStatus || 'DISCONNECTED');
                setQr(res.data.qrCode || '');
            } catch (e) {
                console.error("Erro ao buscar status inicial", e);
            }
        };
        loadInitialStatus();

        const handleQr = d => { 
            if (typeof d === 'string') {
                setQr(d); setStatus('QR'); return;
            }
            if (!d || !d.companyId || String(d.companyId?._id || d.companyId) === String(currentUser?.companyId?._id || currentUser?.companyId)) { 
                setQr(d.qr); 
                setStatus('QR'); 
            } 
        };
        const handleStatus = d => { 
            if (typeof d === 'string') {
                setStatus(d); if (d === 'CONNECTED') setQr(''); return;
            }
            if (!d || !d.companyId || String(d.companyId?._id || d.companyId) === String(currentUser?.companyId?._id || currentUser?.companyId)) { 
                setStatus(d.status); 
                if (d.status === 'CONNECTED') setQr(''); 
            } 
        };
        
        socket.on('qr_code', handleQr);
        socket.on('whatsapp_status', handleStatus);
        
        return () => { 
            socket.off('qr_code', handleQr); 
            socket.off('whatsapp_status', handleStatus); 
        };
    }, [currentUser]);
    const handleReset = async () => {
        if (!window.confirm("Tem certeza?")) return;
        setLoading(true);
        try { await api.delete('/whatsapp/session'); setQr(''); setStatus('DISCONNECTED'); alert("Resetado!"); }
        catch (e) { alert("Erro"); } finally { setLoading(false); }
    };
    return (
        <div className="max-w-xl mx-auto text-center mt-10">
            <div className="bg-white p-10 rounded-xl shadow-lg border">
                <h2 className="text-2xl font-bold mb-6 text-gray-800 flex justify-center items-center"><Wifi className="mr-3 text-blue-600" /> WhatsApp</h2>
                {status === 'CONNECTED' ? (
                    <div className="text-green-600 flex flex-col items-center"><CheckCircle className="w-20 h-20 mb-4" /><p className="text-xl font-bold">Conectado!</p><button onClick={handleReset} disabled={loading} className="mt-8 text-red-600 border border-red-200 bg-red-50 px-4 py-2 rounded-lg text-sm font-bold flex items-center">{loading ? <Loader2 className="animate-spin w-4 h-4 mr-2" /> : <Trash2 className="w-4 h-4 mr-2" />} Desconectar</button></div>
                ) : (
                    <div>{qr ? <QRCodeCanvas value={qr} size={256} className="mx-auto border p-2 rounded-lg" /> : <Loader2 className="w-16 h-16 animate-spin mx-auto text-gray-300" />}<p className="mt-6 text-gray-600 font-medium">Abra o WhatsApp e escaneie.</p><button onClick={handleReset} className="mt-8 text-gray-400 hover:text-red-500 text-xs underline">Forçar novo QR Code</button></div>
                )}
            </div>
        </div>
    );
};

// ==================================================================================
// X. SERVIÇ?OS ç?" MODAL DE VÍNCULO DE EMPRESAS
// ==================================================================================

const CompanyLinkerModal = ({ isOpen, onClose, service }) => {
    const [allCompanies, setAllCompanies] = useState([]);
    const [available, setAvailable] = useState([]);
    const [linked, setLinked] = useState([]);
    const [selectedAvail, setSelectedAvail] = useState([]);
    const [selectedLinked, setSelectedLinked] = useState([]);
    const [searchAvail, setSearchAvail] = useState('');
    const [searchLinked, setSearchLinked] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!isOpen || !service) return;
        const fetchAll = async () => {
            try {
                // Fetch all pages of external companies
                const res = await api.get('/external-companies', { params: { limit: 9999 } });
                const companies = res.data.data || res.data.companies || (Array.isArray(res.data) ? res.data : []);
                setAllCompanies(companies);
                const linkedIds = (service.linkedCompanies || []).map(id => String(id));
                setLinked(companies.filter(c => linkedIds.includes(String(c._id || c.id))));
                setAvailable(companies.filter(c => !linkedIds.includes(String(c._id || c.id))));
            } catch (e) { console.error(e); }
        };
        fetchAll();
        setSelectedAvail([]);
        setSelectedLinked([]);
        setSearchAvail('');
        setSearchLinked('');
    }, [isOpen, service]);

    const toggleSelect = (id, list, setList) => {
        setList(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    const moveToLinked = () => {
        const toMove = available.filter(c => selectedAvail.includes(String(c._id || c.id)));
        setLinked(prev => [...prev, ...toMove]);
        setAvailable(prev => prev.filter(c => !selectedAvail.includes(String(c._id || c.id))));
        setSelectedAvail([]);
    };

    const moveToAvailable = () => {
        const toMove = linked.filter(c => selectedLinked.includes(String(c._id || c.id)));
        setAvailable(prev => [...prev, ...toMove].sort((a, b) => a.name.localeCompare(b.name)));
        setLinked(prev => prev.filter(c => !selectedLinked.includes(String(c._id || c.id))));
        setSelectedLinked([]);
    };

    const moveAllToLinked = () => {
        setLinked(prev => [...prev, ...available]);
        setAvailable([]);
        setSelectedAvail([]);
    };

    const moveAllToAvailable = () => {
        setAvailable(prev => [...prev, ...linked].sort((a, b) => a.name.localeCompare(b.name)));
        setLinked([]);
        setSelectedLinked([]);
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const linkedIds = linked.map(c => c._id || c.id);
            await api.patch(`/services/${service._id || service.id}/linked-companies`, { linkedCompanies: linkedIds });
            onClose(true);
        } catch (e) {
            alert('Erro ao salvar vínculo.');
        } finally { setSaving(false); }
    };

    if (!isOpen) return null;

    const filteredAvail = available.filter(c => c.name?.toLowerCase().includes(searchAvail.toLowerCase()));
    const filteredLinked = linked.filter(c => c.name?.toLowerCase().includes(searchLinked.toLowerCase()));

    return (
        <div className="fixed inset-0 bg-black/60 z-[150] flex items-center justify-center p-4 backdrop-blur-sm">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl flex flex-col" style={{ maxHeight: '90vh' }}>
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b">
                    <div>
                        <h2 className="text-lg font-bold text-gray-800 flex items-center">
                            <Briefcase className="w-5 h-5 mr-2 text-blue-600" />
                            Vincular Empresas - <span className="text-blue-600 ml-1">{service?.name}</span>
                        </h2>
                        <p className="text-xs text-gray-500 mt-0.5">Selecione e mova as empresas para vincular ao serviço.</p>
                    </div>
                    <button onClick={() => onClose(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
                        <X className="w-5 h-5 text-gray-500" />
                    </button>
                </div>

                {/* Body ç?" dual list */}
                <div className="flex gap-3 p-6 flex-1 overflow-hidden">
                    {/* LEFT ç?" Empresas Disponíveis */}
                    <div className="flex-1 flex flex-col border rounded-lg overflow-hidden">
                        <div className="bg-blue-600 text-white text-xs font-bold px-3 py-2 uppercase tracking-wide">
                            Empresas Disponíveis <span className="font-normal opacity-75 ml-1">({filteredAvail.length})</span>
                        </div>
                        <div className="px-2 py-1.5 border-b bg-gray-50">
                            <div className="relative">
                                <Search className="absolute left-2 top-2 w-3.5 h-3.5 text-gray-400" />
                                <input
                                    className="w-full pl-7 pr-2 py-1.5 text-xs border rounded outline-none focus:ring-1 focus:ring-blue-400"
                                    placeholder="Buscar..."
                                    value={searchAvail}
                                    onChange={e => setSearchAvail(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto custom-scrollbar">
                            {filteredAvail.map(c => {
                                const id = String(c._id || c.id);
                                const sel = selectedAvail.includes(id);
                                return (
                                    <div
                                        key={id}
                                        onClick={() => toggleSelect(id, selectedAvail, setSelectedAvail)}
                                        className={`px-3 py-2 text-sm cursor-pointer select-none border-b transition-colors ${sel ? 'bg-blue-100 font-bold text-blue-800' : 'hover:bg-gray-50 text-gray-700'}`}
                                    >
                                        {c.name}
                                    </div>
                                );
                            })}
                            {filteredAvail.length === 0 && <p className="p-4 text-xs text-center text-gray-400 italic">Nenhuma empresa disponível.</p>}
                        </div>
                    </div>

                    {/* CENTER ç?" Arrow Controls */}
                    <div className="flex flex-col items-center justify-center gap-3 shrink-0 py-4">
                        <button onClick={moveAllToLinked} title="Mover todas ç?'" className="p-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors shadow" disabled={available.length === 0}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 5l7 7-7 7M5 5l7 7-7 7" /></svg>
                        </button>
                        <button onClick={moveToLinked} title="Mover selecionados ç?'" className="p-2 bg-gray-200 hover:bg-blue-100 text-blue-700 rounded-lg transition-colors shadow" disabled={selectedAvail.length === 0}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" /></svg>
                        </button>
                        <button onClick={moveToAvailable} title="ç?ç Remover selecionados" className="p-2 bg-gray-200 hover:bg-red-100 text-red-600 rounded-lg transition-colors shadow" disabled={selectedLinked.length === 0}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" /></svg>
                        </button>
                        <button onClick={moveAllToAvailable} title="ç?ç Remover todas" className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors shadow" disabled={linked.length === 0}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" /></svg>
                        </button>
                    </div>

                    {/* RIGHT ç?" Empresas Vinculadas */}
                    <div className="flex-1 flex flex-col border rounded-lg overflow-hidden">
                        <div className="bg-green-600 text-white text-xs font-bold px-3 py-2 uppercase tracking-wide">
                            Empresas Vinculadas <span className="font-normal opacity-75 ml-1">({filteredLinked.length})</span>
                        </div>
                        <div className="px-2 py-1.5 border-b bg-gray-50">
                            <div className="relative">
                                <Search className="absolute left-2 top-2 w-3.5 h-3.5 text-gray-400" />
                                <input
                                    className="w-full pl-7 pr-2 py-1.5 text-xs border rounded outline-none focus:ring-1 focus:ring-green-400"
                                    placeholder="Buscar..."
                                    value={searchLinked}
                                    onChange={e => setSearchLinked(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex-1 overflow-y-auto custom-scrollbar">
                            {filteredLinked.map(c => {
                                const id = String(c._id || c.id);
                                const sel = selectedLinked.includes(id);
                                return (
                                    <div
                                        key={id}
                                        onClick={() => toggleSelect(id, selectedLinked, setSelectedLinked)}
                                        className={`px-3 py-2 text-sm cursor-pointer select-none border-b transition-colors ${sel ? 'bg-green-100 font-bold text-green-800' : 'hover:bg-gray-50 text-gray-700'}`}
                                    >
                                        {c.name}
                                    </div>
                                );
                            })}
                            {filteredLinked.length === 0 && <p className="p-4 text-xs text-center text-gray-400 italic">Nenhuma empresa vinculada.</p>}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 px-6 py-4 border-t bg-gray-50 rounded-b-xl">
                    <button onClick={() => onClose(false)} className="px-5 py-2 text-gray-600 hover:bg-gray-200 font-semibold rounded-lg transition-colors">Cancelar</button>
                    <button onClick={handleSave} disabled={saving} className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow transition-colors flex items-center gap-2 disabled:opacity-60">
                        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle className="w-4 h-4" />}
                        Salvar Vínculos
                    </button>
                </div>
            </div>
        </div>
    );
};

const ServicesPanel = () => {
    const [services, setServices] = useState([]);
    const [form, setForm] = useState({ name: '', description: '', price: '' });
    const [editing, setEditing] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [linkerService, setLinkerService] = useState(null);

    useEffect(() => { load(); }, []);

    const load = async () => {
        try {
            const res = await api.get('/services');
            setServices(res.data || []);
        } catch (e) {
            console.error('Erro ao carregar serviços', e);
        }
    };

    const handleSave = async () => {
        if (!form.name.trim()) return alert("O nome do serviço é obrigatório.");
        try {
            if (editing) {
                await api.put(`/services/${editing}`, form);
            } else {
                await api.post('/services', form);
            }
            setModalOpen(false);
            load();
        } catch (e) {
            alert('Erro ao salvar serviço');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Atenção: Deseja excluir este serviço?")) return;
        try {
            await api.delete(`/services/${id}`);
            load();
        } catch (e) {
            alert('Erro ao deletar serviço');
        }
    };

    const openModal = (s = null) => {
        if (s) {
            setEditing(s._id || s.id);
            setForm({ name: s.name, description: s.description || '', price: s.price || '' });
        } else {
            setEditing(null);
            setForm({ name: '', description: '', price: '' });
        }
        setModalOpen(true);
    };

    return (
        <div className="max-w-4xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold flex items-center text-gray-800"><Briefcase className="mr-2 text-blue-600" /> Serviços Prestados por Contrato</h2>
                <button onClick={() => openModal()} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center shadow-md transition-all">
                    <PlusCircle className="w-4 h-4 mr-2" /> Novo Serviço
                </button>
            </div>

            <div className="bg-white rounded-lg shadow border overflow-hidden">
                <table className="w-full text-left text-sm">
                    <thead className="bg-gray-50 border-b text-gray-500 uppercase text-xs">
                        <tr>
                            <th className="p-4">Serviço</th>
                            <th className="p-4 w-28">Empresas</th>
                            <th className="p-4 text-right">Ações</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y relative">
                        {services.map(s => (
                            <tr key={s._id || s.id} className="hover:bg-gray-50 transition-colors">
                                <td className="p-4">
                                    <div className="font-bold text-gray-800">{s.name}</div>
                                    <div className="text-xs text-gray-500 line-clamp-1">{s.description || '-'}</div>
                                </td>
                                <td className="p-4">
                                    <button
                                        onClick={() => setLinkerService(s)}
                                        title="Vincular Empresas"
                                        className="flex items-center gap-1.5 text-xs font-bold text-purple-700 bg-purple-50 hover:bg-purple-100 border border-purple-200 px-3 py-1.5 rounded-lg transition-colors whitespace-nowrap"
                                    >
                                        <Building className="w-3.5 h-3.5" />
                                        {(s.linkedCompanies || []).length > 0
                                            ? `${s.linkedCompanies.length} vinculada${s.linkedCompanies.length > 1 ? 's' : ''}`
                                            : 'Vincular'}
                                    </button>
                                </td>
                                <td className="p-4 text-right">
                                    <button onClick={() => openModal(s)} className="text-blue-600 hover:bg-blue-50 p-2 rounded mr-1"><Edit2 className="w-4 h-4" /></button>
                                    <button onClick={() => handleDelete(s._id || s.id)} className="text-red-600 hover:bg-red-50 p-2 rounded"><Trash2 className="w-4 h-4" /></button>
                                </td>
                            </tr>
                        ))}
                        {services.length === 0 && (
                            <tr><td colSpan="3" className="p-8 text-center text-gray-400 italic">Nenhum serviço cadastrado.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal Criar/Editar Serviço */}
            <Modal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title={editing ? "Editar Serviço" : "Novo Serviço"}
                confirmText="Salvar"
                onConfirm={handleSave}
            >
                <div className="space-y-4 pt-2 text-sm text-gray-700">
                    <div>
                        <label className="font-bold mb-1 block">Nome do Serviço*</label>
                        <input className="w-full p-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 transition-all font-semibold" placeholder="Ex: Manutenção Preventiva" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
                    </div>
                    <div>
                        <label className="font-bold mb-1 block">Descrição do Serviço</label>
                        <textarea className="w-full p-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 resize-none h-24" placeholder="Breve explicação sobre os detalhes do serviço..." value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
                    </div>
                </div>
            </Modal>

            {/* Modal Vincular Empresas */}
            <CompanyLinkerModal
                isOpen={!!linkerService}
                service={linkerService}
                onClose={(didSave) => {
                    setLinkerService(null);
                    if (didSave) load();
                }}
            />
        </div>
    );
};

export default ConfiguracoesScreen;
